<template>
	<div 
		ref="ocrCreate"
		class="full-container"
		@mousemove="dragging($event)"
		@mouseup="draggend($event)"
	>
		<div class="full-top-wrap">
			OCR Template Create
		</div>
		<div class="full-center-wrap">
			<!-- 좌측 카테고리 영역 -->
			<form @submit.prevent="doValidation()" style="height: 100%;">
				<!-- 우측 상단 CRF Name 영역 -->
				<div class="survey-name-ocr">
					<div class="survey-name-label">
						Template Name
					</div>
					<div class="survey-name-input">
						<input
							type="text"
							name="ocrName"
							v-model="items.ocrName"
							v-validate="'required'"
							data-vv-as="ocrName"
							class="input-crud"
							:class="(errors.has('ocrName') || isDuplicate ? 'input-crud-error' : '')"
							:placeholder="(errors.has('ocrName') ? '* ' + errors.first('ocrName') : 'Please enter the OCR Template Name.')"
							@input="doDuplicateCheck($event.target.value)"
						/>
						<div v-if="isDuplicate" class="duplicate-balloon">
							* Template Name is duplicated.
						</div>
					</div>
					<div class="survey-name-label">
						Sample Image
					</div>
					<div class="survey-name-input">
						<input
							type="file"
							name="myfile"
							ref="myfile"
							v-validate="'required'"
							enctype="multipart/form-data"
							multiple="false"
							hidden
							@change="upload($event.target.name, $event.target.files)"
							@drop="upload($event.target.name, $event.target.files)"
						/>
						<input
							ref="fileName"
							style="border-radius: 0px;"
							type="text"
							class="file-input-crud elipsis-input"
							:title="fileName"
							:value="fileName"
							readonly
						/>
						<button type="button" class="file-btn-crud" @click.stop="openUploader()">
							Upload
						</button>
					</div>
					<div class="survey-name-label">
						Description
					</div>
					<div class="survey-name-input" style="grid-column: 2 / 5">
						<input
							type="text"
							name="description"
							v-model="items.description"
							v-validate="'required'"
							data-vv-as="Procedure Name"
							class="input-crud"
							:placeholder="(errors.has('description') ? '* ' + errors.first('description') : 'Please enter the Description.')"
						/>
					</div>
					<div class="survey-name-label">
						Page Name
					</div>
					<div class="survey-name-input table-set" style="grid-column: 2 / 5">
						<input
							type="text"
							name="pageName"
							v-model="items.pageName"
							v-validate="'required'"
							data-vv-as="Procedure Label"
							class="input-crud"
							disabled
						/>
					</div>
				</div>
				<!-- 중앙 Survey 생성 영역 -->
				<div
					class="survey-center-ocr"
				>
					<div
						ref="uploadFile"
						v-if="!isDrawImage"
						class="survey-left-ocr"
						@click.stop="openUploader()"
					>
						+Upload File
					</div>
					<div
						ref="imageViewer"
						v-if="isDrawImage"
						class="survey-left-ocr"
					>
						<div class="pdf-container">
							<div class="canvas-container" :class="{'canvas-active': selectedOcrField}">
								<!-- <img :src="imageUrl" class="image-viewer" ref="imageViewer" /> -->
								<canvas 
									ref="drawingCanvas" 
									class="drawing-canvas"
									loading="lazy"
									@mousedown="startDrawing"
									@mousemove="draw"
									@mouseup="stopDrawing"
									@mouseleave="stopDrawing"
								></canvas>
							</div>
							<div 
								class="drawing-tools" 
								v-if="isDrawingMode || (selectedOcrField && selectedOcrField.isFocused)"
								:style="{
									top: toolsPosition.y + 'px',
									left: toolsPosition.x + 'px',
									opacity: toolsPosition.visible ? 1 : 0,
									transition: 'opacity 0.2s ease-in-out'
								}"
							>
								<button 
									type="button" 
									class="drawing-tool" 
									@click="saveDrawing" 
									title="Save"
								>
									<span class="tool-icon save-icon">✓</span>
								</button>
								<button 
									type="button" 
									class="drawing-tool" 
									@click="deselectOcrField"
									title="Cancel"
								>
									<span class="tool-icon cancel-icon">✕</span>
								</button>
							</div>
							<!-- <div class="canvas-controls" v-if="selectedOcrField">
								<button type="button" class="canvas-control-btn" @click="deselectOcrField">
									<span>Exit Drawing Mode</span>
								</button>
							</div> -->
						</div>
					</div>
					<div
						class="survey-right-ocr"
					>
						<div
							class="field-spec-header"
						>
							Field Specification
						</div>
						<div
							class="field-spec-sub"
						>
							Field Type
						</div>
						<div
							class="field-type-list"
						>
							<div
								class="field-type-btn"
								@click.stop="openPageSelectModal('square')"
							>
								<div
									class="field-type-img-1"
								>
									<div class="field-type-img-sub">
										A
									</div>
									<div class="field-type-img-sub" style="border-left: none;">
										B
									</div>
								</div>
								<div>
									+Field Add 1
								</div>
							</div>
							<div
								class="field-type-btn"
								@click.stop="openPageSelectModal('divided')"
							>
								<div
									class="field-type-img-2"
									style="border: none;"
								>
									<div class="field-type-img-sub">
										A
									</div>
									<div class="field-type-img-sub">
										B
									</div>
								</div>
								<div>
									+Field Add 2
								</div>
							</div>
							<div
								class="field-type-btn"
								@click.stop="openPageSelectModal('check')"
							>
								<div
									class="field-type-img-3"
								>
								✓
								</div>
								<div>
									+Field Add 3
								</div>
							</div>
						</div>
						<ul class="ocr-field-list">
							<li
								v-for="(ocrFieldItem, index) in ocrFieldList"
								:key="index"
								class="ocr-field-item"
								:class="{ 'selected': selectedOcrField && selectedOcrField.fieldName === (ocrFieldItem.fieldName || ocrFieldItem[0].fieldName || ocrFieldItem[1].fieldName) && selectedOcrField.pageNo === (ocrFieldItem.pageNo || ocrFieldItem[0].pageNo || ocrFieldItem[1].pageNo) }"
								@click="ocrFieldItem.ocrFieldType ? selectOcrField(ocrFieldItem) : selectOcrDividedField(ocrFieldItem)"
							>
								<div class="ocr-field-title">
									<div class="ocr-field-serial">
										<span>Field {{ index + 1 }} [{{ ocrFieldItem.ocrFieldType ? ocrFieldItem.ocrFieldType : (ocrFieldItem[0].ocrFieldType ?? "") }}]</span>
									</div>
									<div class="orc-field-icon">
										<button
											type="button"
											class="btn-edit edit-icon"
											@click.stop="editAnnotation(ocrFieldItem)"
										></button>
										<button
											type="button"
											class="btn-delete"
											@click.stop="deleteOcrField(index)"
										></button>
									</div>
								</div>
								<div
									v-if="ocrFieldItem.ocrFieldType ? ocrFieldItem.ocrFieldType !== 'divided' : ocrFieldItem[0].ocrFieldType !== 'divided'"
									class="ocr-field-content">
									<div class="ocr-field-category">
										<p class="ocr-field-text">
											Field Name
										</p>
									</div>
									<div class="ocr-field-box">
										<p class="ocr-field-text">
											<input
												type="text"
												class="input-crud"
												v-model="ocrFieldItem.fieldName"
												:placeholder="'Field Name ' + (index + 1)"
												@click.stop=""
												@input="updateFieldName(ocrFieldItem)"
											/>
										</p>
									</div>
								</div>
								<ul
									v-if="ocrFieldItem.ocrFieldType ? ocrFieldItem.ocrFieldType === 'divided' : ocrFieldItem[0].ocrFieldType === 'divided'"
								>
									<li
										v-for="(ocrField, idx) in ocrFieldItem"
										:key="idx"
										class="ocr-field-content">
										<div class="ocr-field-category">
											<p class="ocr-field-text">
												{{ String.fromCharCode(65 + idx) }} Field Name
											</p>
										</div>
										<div class="ocr-field-box">
											<p class="ocr-field-text">
												<input
													type="text"
													class="input-crud"
													v-model="ocrField.fieldName"
													:placeholder="'Field Name ' + (idx + 1)"
													@click.stop=""
													@input="updateFieldName(ocrField)"
												/>
											</p>
										</div>
											<!-- A영역과 B영역의 OCR 결과 표시 -->
                                        <!-- <div class="ocr-field-category">
                                            <p class="ocr-field-text">
                                                {{ String.fromCharCode(65 + idx) }} OCR Result
                                            </p>
                                        </div>
                                        <div class="ocr-field-box">
                                            <p class="ocr-field-text ocr-result-text">
                                                {{ ocrField.ocrResult || 'No OCR result yet' }}
                                            </p>
                                        </div> -->
                                    </li>
								</ul>
								<div
									v-if="ocrFieldItem.ocrFieldType === 'check'"
									class="ocr-field-content"
								>	
									<div class="ocr-field-category">
										<p class="ocr-field-text">
											Value
										</p>
									</div>
									<div class="ocr-field-box">
										<p class="ocr-field-text">
											<select
												ref="checkValueSelect"
												name="checkValue"
												class="select-crud"
												:class="errors.has('checkValue') ? 'input-crud-error' : ''"
												v-model="ocrFieldItem.checkValue"
												v-validate="'required'"
												@click.stop=""
												@change.stop=""
											>
												<option value="" disabled>-- Select --</option>
												<option v-for="(checkOption, index) in ocrFieldItem.checkOptions" :key="index" :value="checkOption.checkValue">
													{{ checkOption.checkOption }}
												</option>
											</select>
										</p>
									</div>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</form>
		</div>
		<div class="full-bottom-wrap">
			<button
				v-if="workAccessCheck('PROCEDURE CREATE') && !(projectStateCd == '4' || projectStateCd == '3')"
				type="button"
				class="btn-save fright"
				@click.stop="doSave()"
			>
				Save
			</button>
			<button
				type="button"
				class="btn-cancel fright"
				@click.stop="doCancel()"
				style="margin-right: 10px;"
			>
				Cancel
			</button>
		</div>
		<DefaultValue v-if="isDefaultValue" :defaultField="defaultField" :defaultCellId="defaultCellId"/>
		<OcrPageSelect v-if="isOcrPageSelect" :param="ocrFieldType" @ocr-page-view="openPageViewModal()" @close="isOcrPageSelect = false" />
		<OcrPageView v-if="isOcrPageView" :param="paramSigleCreate" @close="isOcrPageView = false" @ocr-field-save="ocrFieldSave" :ocrFieldList="ocrFieldList" />
	</div>
</template>

<script>
import axios from "axios";
import EventBus from "@/script/EventBus.js";
// import CommonFile from "@/components/common/CommonFile";
import DefaultValue from "@/components/project/procedure/DefaultValue.vue";
import OcrPageSelect from "@/components/project/ocr/modal/OcrPageSelect.vue";
import OcrPageView from "@/components/project/ocr/modal/OcrPageView.vue";

export default {
	name: "OcrCreate",
	components: {
		// CommonFile,
		DefaultValue,
		OcrPageSelect,
		OcrPageView,
	},
	created() {
		this.logger.debug(this, "created()");
		this.items.projectNo = this.$route.params.projectNo;
		this.items.pageNo = this.$route.params.pageNo;
		this.selectSortOrder();
		this.selectFieldList();
		this.selectPageList();
		this.getAccessList('PAGE');
		this.getProjectStateCd();
		
		// OCR 페이지 뷰 이벤트 리스너 추가
		EventBus.$on("ocr-page-view", this.openPageViewModal);
		EventBus.$on("ocr-field-save", this.ocrFieldSave);
	},
	beforeDestroy() {
		// 컴포넌트가 파괴되기 전에 이벤트 리스너 제거
		EventBus.$off("ocr-page-view", this.openPageViewModal);
		EventBus.$off("ocr-field-save", this.ocrFieldSave);
		EventBus.$off("keydown", this.handleEscKey);
	},
	mounted() {
		window.addEventListener('keydown', this.handleEscKey);
	},
	watch: {
		tableRow: function() {
			this.generateGrid();
		},
		tableCol: function() {
			this.generateGrid();
		},
		isDrawImage(newVal) {
			if (newVal) {
				this.$nextTick(() => {
					this.initializeCanvas();
				});
			}
		},
	},
	data() {
		return {
			// 기본 데이터
			toolsPosition: {
				x: 0,
				y: 0,
				visible: false
			},
			items: {},
			searchForm: {},
			fieldList: [],
			fieldCloseList: [],
			pageList: [],
			selectedPageList: [],
			surveyItemList: [],
			defaultField: [],
			defaultCellId: [],
			// 엑셀 관련 데이터
			isTypingEdit: false,
			tableRow: 0,
			tableCol: 0,
			tableData: {},
			columnInfo: {},
			rowInfo: {},
			tableDrag: {
				isDrag: false,
				startId: "",
				endId: ""
			},
			clipBoard: {},
			// 필드 Drag&Drop 데이터
			preview: {
				isPreview: false,
				cellId: "",
			},
			dragData: {
				isDrag: false,
				position: {
					top: "",
					left: "",
				},
				mouseX: "",
				offsetY: "",
				fieldData: {},
			},
			// 상태 확인 데이터
			isTyping: false,
			isDuplicate: false,
			isDefaultValue: false,
			accessList: [],
			projectStateCd: "",
			repeatYn: "",
			// input 동적 데이터
			fileName : "(100MB, Formats:PDF)",
			ocrFile: null,
			ocrFieldType: "",
			isOcrPageSelect: false,
			isOcrPageView: false,
			ocrFieldList: [],
			ocrFieldListLength: 0,
			imageInfo: {
				imageUrl: "",
				imageWidth: 0,
				imageHeight: 0,
			},
			isDrawImage: false,
			imageObj: null,
			isDrawing: false,
			isDrawingMode: false,
			isEditMode: false,
			selectedOcrField: null,
			startX: 0,
			startY: 0,
			rectangle: null,
			canvasActive: false,
			parsedData: {},
		};
	},
	props: {
		value: {
				type: Array,
				default: function() {
					return [];
				},
			},
	},
	computed: {
		usedQuestionNo: function() {
			let usedQuestionNo = this.surveyItemList.map(
				(item) => {
					return item.questionNo;
				}
			);
			return usedQuestionNo;
		}
	},
	methods: {
		selectFieldList() {
			this.logger.debug(this, "selectFieldList()");
			this.searchForm.projectNo = this.$route.params.projectNo;
			axios
				.post(this.config.contextRoot + "/procedure/questionGroupList.do", this.searchForm)
				.then((response) => {
					this.fieldList = response.data;
					for(let g = 0 ; g < this.fieldList.length ; g++)
					{
						for(let q = 0 ; q < this.fieldList[g].questionList.length ; q++)
						{
							for(let f = 0 ; f < this.fieldList[g].questionList[q].fieldList.length ; f++)
							{
								if(this.fieldList[g].questionList[q].fieldList[f].fieldTypeCd == "09")
								{
									this.fieldList[g].questionList[q].fieldList[f].calculate = "";
								}
								this.fieldList[g].questionList[q].fieldList[f].duplicateYn = "N";
							}
						}
					}
					this.$nextTick(function () {
						setTimeout(function() {
							EventBus.$emit("project-loading", false);
						}, 400)
					});
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectPageList() {
			this.logger.debug(this, "selectPageList()");
			axios
				.post(this.config.contextRoot + "/page/selectList.do", {projectNo: this.items.projectNo, searchCategory: "ALL"})
				.then((response) => {
					this.pageList = response.data.pageList;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		selectSortOrder() {
			this.logger.debug(this, "selectSortOrder()");
			axios
				.post(this.config.contextRoot + "/procedure/selectSortOrder.do", {pageNo: this.items.pageNo})
				.then((response) => {
					this.$set(this.items, "procSortOrder", response.data.procSortOrder);
					this.$nextTick(function () {
						// this.$validator.validateAll();
					});
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		fieldTypeName(questionItem){
			var fieldTypeCd = "";
			if(questionItem.fieldList.length > 0){
				fieldTypeCd = questionItem.fieldList[0].fieldTypeCd;
			}
			if(fieldTypeCd=="01"){
				return "type_01";
			}
			else if(fieldTypeCd=="02"){
				return "type_02";
			}
			else if(fieldTypeCd=="03"){
				return "type_03";
			}
			else if(fieldTypeCd=="04"){
				return "type_04";
			}
			else if(fieldTypeCd=="05"){
				return "type_05";
			}
			else if(fieldTypeCd=="06"){
				return "type_06";
			}
			else if(fieldTypeCd=="07"){
				return "type_07";
			}
			else if(fieldTypeCd=="08"){
				return "type_08";
			}
			else if(fieldTypeCd=="09"){
				return "type_09";
			}
			else if(fieldTypeCd=="10"){
				return "type_10";
			}
			else if(fieldTypeCd=="11"){
				return "type_11";
			}
			else if(fieldTypeCd=="12"){
				return "type_12";
			}
			else {
				return "";
			}
		},
		foldField(questionGroupNo) {
			this.logger.debug(this, "foldField(questionGroupNo)");
			let index = this.fieldCloseList.indexOf(questionGroupNo);
			if(index >= 0)
			{
				this.fieldCloseList.splice(index, 1);
			}
			else
			{
				this.fieldCloseList.push(questionGroupNo);
			}
		},
		keyupHandler(event) {
			this.logger.debug(this, "keyupHandler(event)");
			this.searchForm.searchText = event.target.value;
			this.searchForm.projectNo = this.$route.params.projectNo;
			if (event.keyCode == 13)
			{
				EventBus.$emit("project-loading", true);
				this.selectFieldList();
			}
		},
		infoBalloon(event) {
			this.logger.debug(this, "infoBalloon(event)");
			if(event.type == "focus")
			{
				this.isTyping = true;
			}
			else
			{
				this.$refs.typingBalloon.style.animation = "hideBalloon 0.3s ease-out both";
				setTimeout(function() {
					this.$refs.typingBalloon.style.animation = "";
					this.isTyping = false;
				}.bind(this), 310);
			}
		},
		doDuplicateCheck(ocrName) {
			this.logger.debug(this, "doDuplicateCheck(ocrName");
			if(ocrName != "" && ocrName != null && ocrName !== undefined) this.$set(this.items, "ocrName", ocrName);
			axios
				.post(this.config.contextRoot + "/ocr/duplicateCheck.do", this.items)
				.then((response) => {
					if(response.data.ocrExistCount == 0)
					{
						this.isDuplicate = false;
					}
					else
					{
						this.isDuplicate = true;
					}
				});
		},
		generateGrid() {
			let usedKey = [];
			
			for(let col = 1; col <= this.tableCol; col++) {
				const columnId = String.fromCharCode(64 + col);
				if (!this.columnInfo[columnId]) {
					this.$set(this.columnInfo, columnId, { width: "100%" });
				}
			}
			
			if (this.isManualAdjustment) {
				this.handleManualAdjustment();
			}
			
			for(let col = 1 ; col <= this.tableCol ; col++)
			{
				for(let row = 1 ; row <= this.tableRow ; row++)
				{
					// cell Data 생성
					let keys = Object.keys(this.tableData);
					let id = String.fromCharCode(64 + col) + row;
					
					usedKey.push(id);
					if(keys.indexOf(id) < 0)
					{
						let data = {
							isFocus: false,
							isExpand: false,
							expandCol: 1,
							expandRow: 1,
							repeatCol: 1,
							repeatRow: 1,
							expandRoot: "",
							repeatRoot: "",
							isHeader: false,
							isText: false,
							isRepeat: false,
							align: "left",
							text: "",
							field: {}
						};
						this.$set(this.tableData, id, data);
					}
				}
			}
			
			// 미사용 Cell Data 삭제
			let keyArray = Object.keys(this.tableData);
			for(let i = 0 ; i < keyArray.length ; i++)
			{
				if(usedKey.indexOf(keyArray[i]) < 0)
				{
					if(this.tableData[keyArray[i]].isExpand)
					{
						let rootId = this.tableData[keyArray[i]].expandRoot;
						let rootStartCol = Number(rootId.slice(0, 1).charCodeAt(0));
						let rootEndCol = Number(rootStartCol + this.tableData[rootId].expandCol - 1);
						let rootStartRow = Number(rootId.slice(1));
						let rootEndRow = Number(rootStartRow + this.tableData[rootId].expandRow - 1);
						for(let c = rootStartCol ; c <= rootEndCol ; c++)
						{
							for(let r = rootStartRow ; r <= rootEndRow ; r++)
							{
								let id = String.fromCharCode(c) + r;
								this.$set(this.tableData[id], "isFocus", false);
								this.$set(this.tableData[id], "isExpand", false);
								this.$set(this.tableData[id], "expandCol", 1);
								this.$set(this.tableData[id], "expandRow", 1);
								this.$set(this.tableData[id], "expandRoot", "");
								this.$set(this.tableData[id], "isRepeat", false);
								this.$set(this.tableData[id], "repeatCol", 1);
								this.$set(this.tableData[id], "repeatRow", 1);
								this.$set(this.tableData[id], "repeatRoot", "");
							}
						}
					}
					this.$delete(this.tableData, keyArray[i]);
				}
			}
		},
		cellStyle(id) {
			let style = {};
			let cell = this.tableData[id];
			
			if(cell.isExpand && cell.expandCol < 2 && cell.expandRow < 2)
			{
				style.display = "none";
			}
			if(cell.isHeader)
			{
				style.backgroundColor = "#f5f5f5";
				style.fontWeight = "600";
			}
			if(cell.isFocus)
			{
				style.backgroundColor = "#00579211";
			}
			if(this.dragData.isDrag)
			{
				style.opacity = "0.9";
			}
			if(this.preview.isPreview && this.preview.cellId == id)
			{
				style.backgroundColor = "#eef4f8";
			}
			
			
			style.textAlign = cell.align;
			style.justifyContent = cell.align;
			
			return style;
		},
		selectCell(event) {
			this.initialFocus();
			let getPath = this.utils.getEventPath(event);
			let nodePath = getPath.map((item) => {
				return item.nodeName;
			});
			let tdIndex = nodePath.indexOf("TD");
			let id = getPath[tdIndex].id;
			if(this.tableData[id].isRepeat){
				let rootId = this.tableData[id].repeatRoot;
				let rootStartCol = Number(rootId.slice(0, 1).charCodeAt(0));
				let rootEndCol = Number(rootStartCol + this.tableData[rootId].repeatCol - 1);
				let rootStartRow = Number(rootId.slice(1));
				let rootEndRow = Number(rootStartRow + this.tableData[rootId].repeatRow - 1);
				for(let c = rootStartCol ; c <= rootEndCol ; c++)
				{
					for(let r = rootStartRow ; r <= rootEndRow ; r++)
					{
						let id = String.fromCharCode(c) + r;
						this.$set(this.tableData[id], "isFocus", true);
					}
				}
			}
			else if(this.tableData[id].isExpand && !this.tableData[id].isRepeat)
			{
				let rootId = this.tableData[id].expandRoot;
				let rootStartCol = Number(rootId.slice(0, 1).charCodeAt(0));
				let rootEndCol = Number(rootStartCol + this.tableData[rootId].expandCol - 1);
				let rootStartRow = Number(rootId.slice(1));
				let rootEndRow = Number(rootStartRow + this.tableData[rootId].expandRow - 1);
				for(let c = rootStartCol ; c <= rootEndCol ; c++)
				{
					for(let r = rootStartRow ; r <= rootEndRow ; r++)
					{
						let id = String.fromCharCode(c) + r;
						this.$set(this.tableData[id], "isFocus", true);
					}
				}
			}
			else
			{
				this.$set(this.tableData[id], "isFocus", true);
			}
		},
		selectColumn(column) {
			this.initialFocus();
			
			let keys = Object.keys(this.tableData);
			for(let i = 0 ; i < Object.keys(this.tableData).length ; i++)
			{
				if(keys[i].slice(0, 1) == column)
				{
					if(this.tableData[keys[i]].isExpand)
					{
						let rootId = this.tableData[keys[i]].expandRoot;
						let rootCol = Number(rootId.slice(0, 1).charCodeAt(0));
						let rootRow = Number(rootId.slice(1));
						let rootColLength = rootCol + Number(this.tableData[rootId].expandCol) - 1;
						let rootRowLength = rootRow + Number(this.tableData[rootId].expandRow) - 1;
						
						for(let c = rootCol ; c <= rootColLength ; c++)
						{
							for(let r = rootRow ; r <= rootRowLength ; r++)
							{
								let id = String.fromCharCode(c) + r;
								this.$set(this.tableData[id], "isFocus", true);
							}
						}
					}
					else
					{
						this.$set(this.tableData[keys[i]], "isFocus", true);
					}
				}
			}
		},
		selectRow(row) {
			this.initialFocus();
			
			let keys = Object.keys(this.tableData);
			for(let i = 0 ; i < Object.keys(this.tableData).length ; i++)
			{
				if(keys[i].slice(1) == row)
				{
					if(this.tableData[keys[i]].isExpand)
					{
						let rootId = this.tableData[keys[i]].expandRoot;
						let rootCol = Number(rootId.slice(0, 1).charCodeAt(0));
						let rootRow = Number(rootId.slice(1));
						let rootColLength = rootCol + Number(this.tableData[rootId].expandCol) - 1;
						let rootRowLength = rootRow + Number(this.tableData[rootId].expandRow) - 1;
						
						for(let c = rootCol ; c <= rootColLength ; c++)
						{
							for(let r = rootRow ; r <= rootRowLength ; r++)
							{
								let id = String.fromCharCode(c) + r;
								this.$set(this.tableData[id], "isFocus", true);
							}
						}
					}
					else
					{
						this.$set(this.tableData[keys[i]], "isFocus", true);
					}
				}
			}
		},
		selectAllCell() {
			for(let col = 1 ; col <= this.tableCol ; col++)
			{
				for(let row = 1 ; row <= this.tableRow ; row++)
				{
					let id = String.fromCharCode(64 + col) + row;
					this.$set(this.tableData[id], "isFocus", true);
				}
			}
		},
		initialFocus() {
			let keys = Object.keys(this.tableData);
			for(let i = 0 ; i < Object.keys(this.tableData).length ; i++)
			{
				this.$set(this.tableData[keys[i]], "isFocus", false);
			}
		},
		gridDragStart(event) {
			let getPath = this.utils.getEventPath(event);
			let nodePath = getPath.map((item) => {
				return item.nodeName;
			});
			let tdIndex = nodePath.indexOf("TD");
			let startId = getPath[tdIndex].id;
			this.$set(this.tableDrag, "isDrag", true);
			this.$set(this.tableDrag, "startId", startId);
		},
		gridDragging(event) {
			this.initialFocus();
			
			let getPath = this.utils.getEventPath(event);
			let nodePath = getPath.map((item) => {
				return item.nodeName;
			});
			let tdIndex = nodePath.indexOf("TD");
			let endId = getPath[tdIndex].id;
			this.$set(this.tableDrag, "endId", endId);
			
			let startCol = Number(this.tableDrag.startId.slice(0, 1).charCodeAt(0));
			let startRow = Number(this.tableDrag.startId.slice(1));
			let endCol = Number(endId.slice(0, 1).charCodeAt(0));
			let endRow = Number(endId.slice(1));
			
			let col = (startCol < endCol ? startCol : endCol);
			let colLength = (startCol < endCol ? endCol : startCol);
			let row = (startRow < endRow ? startRow : endRow);
			let rowLength = (startRow < endRow ? endRow : startRow);
			
			let minCol = col;
			let maxCol = colLength;
			let minRow = row;
			let maxRow = rowLength;
			let expandCell = [];
			let repeatCell = [];
			
			let loof = true;
			while(loof)
			{
				for(let c = col ; c <= colLength ; c++)
				{
					for(let r = row ; r <= rowLength ; r++)
					{
						let id = String.fromCharCode(c) + r;
						if(this.tableData[id].isExpand)
						{
							
							let rootId = this.tableData[id].expandRoot;
							let rootStartCol = Number(rootId.slice(0, 1).charCodeAt(0));
							let rootEndCol = Number(rootStartCol + this.tableData[rootId].expandCol - 1);
							let rootStartRow = Number(rootId.slice(1));
							let rootEndRow = Number(rootStartRow + this.tableData[rootId].expandRow - 1);
							
							if(rootStartCol < minCol) minCol = rootStartCol;
							if(rootEndCol > maxCol) maxCol = rootEndCol;
							if(rootStartRow < minRow) minRow = rootStartRow;
							if(rootEndRow > maxRow) maxRow = rootEndRow;
							
							if(expandCell.indexOf(rootId) < 0) expandCell.push(rootId);
						}
						if(this.tableData[id].isRepeat)
						{
							
							let rootId = this.tableData[id].repeatRoot;
							let rootStartCol = Number(rootId.slice(0, 1).charCodeAt(0));
							let rootEndCol = Number(rootStartCol + this.tableData[rootId].repeatCol - 1);
							let rootStartRow = Number(rootId.slice(1));
							let rootEndRow = Number(rootStartRow + this.tableData[rootId].repeatRow - 1);
							
							if(rootStartCol < minCol) minCol = rootStartCol;
							if(rootEndCol > maxCol) maxCol = rootEndCol;
							if(rootStartRow < minRow) minRow = rootStartRow;
							if(rootEndRow > maxRow) maxRow = rootEndRow;
							
							if(repeatCell.indexOf(rootId) < 0) repeatCell.push(rootId);
						}
					}
				}
				
				let cancel = false;
				for(let c = minCol ; c <= maxCol ; c++)
				{
					for(let r = minRow ; r <= maxRow ; r++)
					{
						let id = String.fromCharCode(c) + r;
						if(this.tableData[id].isExpand && expandCell.indexOf(this.tableData[id].expandRoot) < 0)
						{
							cancel = true;
							col = minCol;
							colLength = maxCol;
							row = minRow;
							rowLength = maxRow;
							break;
						}
						else
						{
							this.$set(this.tableData[id], "isFocus", true);
						}
					}
					if(cancel) break;
				}
				if(!cancel) loof = false;
			}
		},
		gridDraggEnd() {
			this.$set(this.tableDrag, "isDrag", false);
			this.$set(this.tableDrag, "startId", "");
			this.$set(this.tableDrag, "endId", "");
		},
		mergeCell() {
			this.deleteData();
			let keys = Object.keys(this.tableData);
			let colArray = [];
			let rowArray = [];
			let expandArray = [];
			for(let i = 0 ; i < keys.length ; i++)
			{
				if(this.tableData[keys[i]].isFocus)
				{
					if(this.tableData[keys[i]].isRepeat)
					{
						this.$alert("Please release the repeat area.","Warning","warning");
						return false;
					}
					if(this.tableData[keys[i]].isExpand)
					{
						this.revertCell();
						return;
					}
					else
					{
						colArray.push(keys[i].slice(0, 1).charCodeAt(0));
						rowArray.push(Number(keys[i].slice(1)));
						expandArray.push(keys[i]);
					}
				}
			}
			
			if(colArray.length > 1 && rowArray.length > 1)
			{
				let minCol = Math.min(...colArray);
				let maxCol = Math.max(...colArray);
				let minRow = Math.min(...rowArray);
				let maxRow = Math.max(...rowArray);
				
				let targetId = String.fromCharCode(minCol) + minRow;
				let expandCol = maxCol - minCol + 1;
				let expandRow = maxRow - minRow + 1;
				
				this.$set(this.tableData[targetId], "expandCol", expandCol);
				this.$set(this.tableData[targetId], "expandRow", expandRow);
				
				for(let i = 0 ; i < expandArray.length ; i++)
				{
					let usedIndex = -1;
					this.surveyItemList.forEach((item, index)=>{
						if(expandArray[i] == item.cellName){
							usedIndex = index;
						}
					})
					
					// let usedIndex = this.usedQuestionNo.indexOf(this.tableData[expandArray[i]].field.questionNo);
					if(usedIndex >= 0) this.surveyItemList.splice(usedIndex, 1);
					
					this.$set(this.tableData[expandArray[i]], "isExpand", true);
					this.$set(this.tableData[expandArray[i]], "expandRoot", targetId);
					this.$set(this.tableData[expandArray[i]], "isText", false);
					this.$set(this.tableData[expandArray[i]], "text", "");
					this.$set(this.tableData[expandArray[i]], "field", {});
				}
			}
		},
		revertCell() {
			let keys = Object.keys(this.tableData);
			for(let i = 0 ; i < keys.length ; i++)
			{
				if(this.tableData[keys[i]].isFocus)
				{
					if(this.tableData[keys[i]].isRepeat)
					{
						this.$alert("Please release the repeat area.","Warning","warning");
						return false;
					}
					this.$set(this.tableData[keys[i]], "isExpand", false);
					this.$set(this.tableData[keys[i]], "expandCol", 1);
					this.$set(this.tableData[keys[i]], "expandRow", 1);
					this.$set(this.tableData[keys[i]], "expandRoot", "");
				}
			}
		},
		setHeader() {
			let keys = Object.keys(this.tableData);
			let isUnset = true;
			for(let i = 0 ; i < keys.length ; i++)
			{
				if(this.tableData[keys[i]].isFocus)
				{
					if(this.tableData[keys[i]].isRepeat)
					{
						this.$alert("Please release the repeat area.","Warning","warning");
						return false;
					}
					if(this.tableData[keys[i]].isHeader)
					{
						if(this.tableData[keys[i]].field.fieldList && ['7','8', '9', '11', '12', '13'].includes(this.tableData[keys[i]].field.fieldList[0].dataTypeCd)){
							this.$alert("Unable to release header.\nNot allowed for list type Fields.","Warning","warning");
						}
						else if(this.usedQuestionNo.indexOf(this.tableData[keys[i]].field.questionNo) >= 0 && !['7','8', '9', '11', '12', '13'].includes(this.tableData[keys[i]].field.fieldList[0].dataTypeCd)){
							this.$alert("Unable to release header. Same field is in use.","Warning","warning");
						}
						else{
							isUnset = false;
							break;
						}
					}
				}
			}
			for(let i = 0 ; i < keys.length ; i++)
			{
				if(this.tableData[keys[i]].isFocus)
				{
					if(this.tableData[keys[i]].isExpand)
					{
						let rootId = this.tableData[keys[i]].expandRoot;
						this.$set(this.tableData[rootId], "isHeader", isUnset);
						
						if(Object.keys(this.tableData[rootId].field).length !== 0)
						{
							if(isUnset)
							{
								let usedIndex = this.usedQuestionNo.indexOf(this.tableData[rootId].field.questionNo);
								if(usedIndex >= 0) this.surveyItemList.splice(usedIndex, 1);
							}
							else
							{
								let usedIndex = this.usedQuestionNo.indexOf(this.tableData[rootId].field.questionNo);
								if(usedIndex < 0) this.surveyItemList.push(this.tableData[rootId].field);
							}
						}
					}
					else
					{
						this.$set(this.tableData[keys[i]], "isHeader", isUnset);
						
						if(Object.keys(this.tableData[keys[i]].field).length !== 0)
						{
							if(isUnset)
							{
								let usedIndex = this.usedQuestionNo.indexOf(this.tableData[keys[i]].field.questionNo);
								if(usedIndex >= 0) this.surveyItemList.splice(usedIndex, 1);
							}
							else
							{
								let usedIndex = this.usedQuestionNo.indexOf(this.tableData[keys[i]].field.questionNo);
								if(usedIndex < 0) this.surveyItemList.push(this.tableData[keys[i]].field);
							}
						}
					}
				}
			}
		},
		setTyping() {
			this.deleteData();
			let keys = Object.keys(this.tableData);
			let isUnset = true;
			for(let i = 0 ; i < keys.length ; i++)
			{
				if(this.tableData[keys[i]].isFocus)
				{
					if(this.tableData[keys[i]].isRepeat)
					{
						this.$alert("Please release the repeat area.","Warning","warning");
						return false;
					}
					if(this.tableData[keys[i]].isText)
					{
						isUnset = false;
						break;
					}
				}
			}
			
			for(let i = 0 ; i < keys.length ; i++)
			{
				if(this.tableData[keys[i]].isFocus)
				{
					if(this.tableData[keys[i]].isExpand)
					{
						let rootId = this.tableData[keys[i]].expandRoot;
						if(!this.tableData[rootId].isHeader && Object.keys(this.tableData[rootId].field).length !== 0)
						{
							let usedIndex = -1;
							this.surveyItemList.forEach((item, index)=>{
								if(rootId == item.cellName){
									usedIndex = index;
								}
							})
							// let usedIndex = this.usedQuestionNo.indexOf(this.tableData[rootId].field.questionNo);
							if(usedIndex >= 0) this.surveyItemList.splice(usedIndex, 1);
						}
						
						this.$set(this.tableData[rootId], "isText", isUnset);
						this.$set(this.tableData[rootId], "text", "");
						this.$set(this.tableData[rootId], "field", {});
					}
					else
					{
						if(!this.tableData[keys[i]].isHeader && Object.keys(this.tableData[keys[i]].field).length !== 0)
						{
							let usedIndex = -1;
							this.surveyItemList.forEach((item, index)=>{
								if(keys[i] == item.cellName){
									usedIndex = index;
								}
							})
							// let usedIndex = this.usedQuestionNo.indexOf(this.tableData[keys[i]].field.questionNo);
							if(usedIndex >= 0) this.surveyItemList.splice(usedIndex, 1);
						}
						
						this.$set(this.tableData[keys[i]], "isText", isUnset);
						this.$set(this.tableData[keys[i]], "text", "");
						this.$set(this.tableData[keys[i]], "field", {});
					}
				}
			}
		},
		setTextEdit(event) {
			let getPath = this.utils.getEventPath(event);
			let nodePath = getPath.map((item) => {
				return item.nodeName;
			});
			let tdIndex = nodePath.indexOf("TD");
			let id = getPath[tdIndex].id + "_text";
			if(this.tableData[getPath[tdIndex].id].isText)
			{
				this.isTypingEdit = true;
				this.$nextTick(() => {
					document.getElementById(id).focus();
				});
			}
		},
		setAlign(direction) {
			let keys = Object.keys(this.tableData);
			for(let i = 0 ; i < keys.length ; i++)
			{
				if(this.tableData[keys[i]].isFocus)
				{
					if(this.tableData[keys[i]].isExpand)
					{
						let rootId = this.tableData[keys[i]].expandRoot;
						this.$set(this.tableData[rootId], "align", direction);
					}
					else
					{
						this.$set(this.tableData[keys[i]], "align", direction);
					}
				}
			}
		},
		setRepeat() {
			let keys = Object.keys(this.tableData);
			let minCol = 999;
			let maxCol = 0;
			let rootCount = [];
			let fieldCount = 0;
			this.getWidthHeight();
			for(let i = 0 ; i < keys.length ; i++)
			{
				if(this.tableData[keys[i]].isFocus)
				{
					let rootId = keys[i].slice(0,1);
					let col = Number(keys[i].slice(0, 1).charCodeAt(0));
					if(minCol > col)
					{
						minCol = col;
					}
					if(maxCol < col)
					{
						maxCol = col;	
					}
					rootCount.push(rootId);
					if(Object.keys(this.tableData[keys[i]].field).length > 0 && !this.tableData[keys[i]].isHeader){
						fieldCount += 1;
					}
				}
			}
			// let size = 0;
			let countResult = rootCount.reduce((accu,curr)=> {
				accu.set(curr, (accu.get(curr)||0) +1) ;
				return accu;
			},new Map());
			
			// for (let [key, value] of countResult.entries()) {
			// 	console.log(key + ' : ' + value);
			// 	size++;
			// }
			// console.log(size);
			
			let values = new Set(countResult.values());
			
			
			if((maxCol-minCol+1) != this.tableCol)
			{
				this.$alert("The cell cannot be repeat\n Specify the column as maximum length","Warning","warning");
				return false;
			}
			if(values.size != 1) {
				this.$alert("The cell cannot be repeat\n Specify the column as maximum length","Warning","warning");
				return false;
			}
			if(fieldCount == 0){
				this.$alert("The cell cannot be repeat\n doesn't have fields","Warning","warning");
				return false;
			}
			let pageVo = {};
			this.pageList.forEach(item => {
				if(item.pageNo == this.$route.params.pageNo){
					pageVo = item;
				}
			});
			if(pageVo.pageUsedReapetProcNo != 0){
				this.$alert("The repeat function is already in use within that page!","Warning","warning");
				return false;
			}
			// 조건 충족시
			if((maxCol-minCol+1) == this.tableCol && values.size == 1)
			{
				let colArray = [];
				let rowArray = [];
				let repeatArray = [];
				for(let i = 0 ; i < keys.length ; i++)
				{
					if(this.tableData[keys[i]].isFocus)
					{
						if(this.tableData[keys[i]].isRepeat)
						{
							this.revertRepeat();
							return;
						}
						else
						{
							colArray.push(keys[i].slice(0, 1).charCodeAt(0));
							rowArray.push(Number(keys[i].slice(1)));
							repeatArray.push(keys[i]);
						}
					}
				}
				if(colArray.length >= 1 && rowArray.length >= 1 && this.repeatYn == "")
				{
					let minCol = Math.min(...colArray);
					let maxCol = Math.max(...colArray);
					let minRow = Math.min(...rowArray);
					let maxRow = Math.max(...rowArray);
					
					let targetId = String.fromCharCode(minCol) + minRow;
					let repeatCol = maxCol - minCol + 1;
					let repeatRow = maxRow - minRow + 1;
					this.$set(this.tableData[targetId], "repeatCol", repeatCol);
					this.$set(this.tableData[targetId], "repeatRow", repeatRow);
					
					for(let i = 0 ; i < repeatArray.length ; i++)
					{
						this.$set(this.tableData[repeatArray[i]], "isRepeat", true);
						this.$set(this.tableData[repeatArray[i]], "repeatRoot", targetId);
						this.repeatYn = targetId;
					}
				}
			}
		},
		revertRepeat() {
			let keys = Object.keys(this.tableData);
			let minRow = 0;
			let maxRow = 0;
			let countArr = [];
			let rootIdArr = [];
			for(let i = 0 ; i < keys.length ; i++)
			{
				if(this.tableData[keys[i]].isFocus && this.tableData[keys[i]].isRepeat)
				{
					let rootId = keys[i].slice(1, 10);
					countArr.push(rootId);
					
					rootIdArr.push(this.tableData[keys[i]].repeatRoot);
					this.$set(this.tableData[keys[i]], "isRepeat", false);
					this.$set(this.tableData[keys[i]], "repeatRoot", "");
					this.$set(this.tableData[keys[i]], "repeatCol", 1);
					this.$set(this.tableData[keys[i]], "repeatRow", 1);
				}
			}
			minRow = Math.min(...countArr);
			maxRow = Math.max(...countArr);
			if(minRow == maxRow)
			{
				document.getElementById(minRow).style.resize = "vertical";
			} 
			else
			{
				for(let i = minRow ; i <= maxRow; i++)
				
				{
					document.getElementById(i).style.resize = "vertical";
				}
			}
			this.repeatYn = "";
		},
		makeRepeatDiv(targetId){
			let keys = Object.keys(this.tableData);
			let minRow = 0;
			let maxRow = 0;
			let countArr = [];
			let style = {};
			
			for(let i = 0 ; i < keys.length ; i++)
			{
				if(this.tableData[keys[i]].isRepeat && this.tableData[keys[i]].repeatRoot == targetId)
				{
					let rootId = keys[i].slice(1, 10);
					countArr.push(rootId);
				}
			}
			minRow = Math.min(...countArr);
			maxRow = Math.max(...countArr);
			
			//세로
			let totalHeight = 0;
			if(minRow == maxRow)
			{
				this.$nextTick(() => {
					document.getElementById(minRow).style.resize="none";
				});
				totalHeight = Number(this.rowInfo[minRow].height.replace('px', ''));
			} 
			else
			{
				for(let i = minRow ; i <= maxRow; i++)
				
				{
					this.$nextTick(() => {
						document.getElementById(i).style.resize="none";
					});
					totalHeight += Number(this.rowInfo[i].height.replace('px', ''));
				}
			}
			//가로
			
			let tableWidth = this.$refs.procedureForm.offsetWidth - 35;
			
			style.height = totalHeight + "px";
			style.width = (tableWidth) + "px";
			style.border = "2px solid #2bade0";
			style.backgroundColor = "transparent";
			style.position = "absolute";
			style.top = "0";
			style.zIndex = "20";
			
			return style;
		},
		addRow() {
			let keys = Object.keys(this.tableData);
			let minCol = 999;
			let maxCol = 0;
			let rootCount = [];
			this.getWidthHeight();
			for(let i = 0 ; i < keys.length ; i++)
			{
				if(this.tableData[keys[i]].isFocus)
				{
					let rootId = keys[i].slice(0,1);
					let col = Number(keys[i].slice(0, 1).charCodeAt(0));
					if(minCol > col)
					{
						minCol = col;
					}
					if(maxCol < col)
					{
						maxCol = col;	
					}
					rootCount.push(rootId);
				}
			}
			// let size = 0;
			let countResult = rootCount.reduce((accu,curr)=> {
				accu.set(curr, (accu.get(curr)||0) +1) ;
				return accu;
			},new Map());
			
			// for (let [key, value] of countResult.entries()) {
			// 	console.log(key + ' : ' + value);
			// 	size++;
			// }
			// console.log(size);
			
			let values = new Set(countResult.values());
			
			
			if((maxCol-minCol+1) != this.tableCol)
			{
				this.$alert("The cell cannot be repeat\n Specify the column as maximum length","Warning","warning");
				return false;
			}
			if(values.size != 1) {
				this.$alert("The cell cannot be repeat\n Specify the column as maximum length","Warning","warning");
				return false;
			}
			// 조건 충족시
			this.tableRow += 1;
			
			//선택한 행 값 가져오기
			let focusRow = "";
			let focusList = [];
			for(let i = 0 ; i < keys.length ; i++)
			{
				if(this.tableData[keys[i]].isFocus)
				{
					focusList.push(keys[i].slice(1));
				}
			}
			focusRow = focusList[0];
			
			//선택한 행 아래 모든 행 데이터 복사
			let repeatArr = [];
			for(let i = 0 ; i < keys.length ; i++)
			{
				let keysnum = parseInt(keys[i].slice(1));
				if(keysnum >= parseInt(focusRow))
				{
					repeatArr.push({cellName : keys[i], data : JSON.parse(JSON.stringify(this.tableData[keys[i]]))})
				}
			}
			
			//row height 데이터 복사
			let rowArr = [];
			for(let i = 0 ; i < Object.keys(this.rowInfo).length; i++){
				rowArr.push(JSON.parse(JSON.stringify(this.rowInfo[Object.keys(this.rowInfo)[i]])));
			}
			
			//복사한 데이터 정렬
			repeatArr.sort(function(a,b){
				if(a.row == b.row){
					var x = a.cellName.toLowerCase(), y = b.cellName.toLowerCase();
					return x < y ? -1 : x > y ? 1 : 0;
				}
				return a.row - b.row;
			});
			
			//복사한 데이터 한줄씩 미뤄서 삽입 및 추가된 행 데이터 제거
			this.$nextTick(function () {
				keys = Object.keys(this.tableData);
				
				let cellNameList = [];
				let subNameList = [];
				for(let i = 0 ; i < keys.length ; i++)
				{
					for(let j = 0; j < repeatArr.length; j++){
						if(keys[i] == repeatArr[j].cellName){
							let num = parseInt(repeatArr[j].cellName.slice(1)) + 1;
							let subName = keys[i].slice(0, 1) + num.toString();
							this.tableData[subName] = repeatArr[j].data;
							this.tableData[subName].cellName = subName;
							
							for(let t = 0; t < this.surveyItemList.length; t++){
								if(keys[i] == this.surveyItemList[t].cellName){
									cellNameList.push(keys[i]);
								}
							}
							
							if(this.tableData[subName].isExpand){
								let rootNum = parseInt(this.tableData[subName].expandRoot.slice(1)) + 1;
								this.tableData[subName].expandRoot = this.tableData[subName].expandRoot.slice(0, 1) + rootNum.toString();
							}
							if(this.tableData[subName].isRepeat){
								let reapetNum = parseInt(this.tableData[subName].repeatRoot.slice(1)) + 1;
								this.tableData[subName].repeatRoot = this.tableData[subName].repeatRoot.slice(0, 1) + reapetNum.toString();
							}
						}
					}
				}
				
				for(let t = 0; t < this.surveyItemList.length; t++){
					for(let k = 0; k < cellNameList.length; k++){
						if(cellNameList[k] == this.surveyItemList[t].cellName){
							subNameList.push(this.surveyItemList[t]);
						}
					}
				}
				for(let i = 0; i < subNameList.length; i++){
					let rowNum = parseInt(subNameList[i].cellName.slice(1)) + 1;
					subNameList[i].cellName = subNameList[i].cellName.slice(0, 1) + rowNum.toString();
				}
				
				for(let i = 0 ; i < keys.length ; i++)
				{
					if(keys[i].slice(1) == focusRow)
					{
						this.tableData[keys[i]].align = "left";
						this.tableData[keys[i]].expandCol = 1;
						this.tableData[keys[i]].expandRoot = "";
						this.tableData[keys[i]].expandRow = 1;
						this.tableData[keys[i]].field = {};
						this.tableData[keys[i]].isExpand = false;
						this.tableData[keys[i]].isFocus = false;
						this.tableData[keys[i]].isHeader = false;
						this.tableData[keys[i]].isRepeat = false;
						this.tableData[keys[i]].isText = false;
						this.tableData[keys[i]].repeatCol = 1;
						this.tableData[keys[i]].repeatRoot = "";
						this.tableData[keys[i]].repeatRow = 1;
						this.tableData[keys[i]].text = "";
					}
				}

				//row height 데이터 셋팅
				this.getWidthHeight();
				for(let i = 0 ; i < Object.keys(this.rowInfo).length; i++){
					if(parseInt(Object.keys(this.rowInfo)[i]) > parseInt(focusRow)){
						this.rowInfo[Object.keys(this.rowInfo)[i]] = rowArr[Object.keys(this.rowInfo)[i]-2];
					}
				}
				this.rowInfo[focusRow].height = "50px";
				this.rowInfo[focusRow].rowRepeat = "";
				this.setRowStyle();
			});
		},
		deleteRow() {
			this.deleteData();
			let keys = Object.keys(this.tableData);
			let minCol = 999;
			let maxCol = 0;
			let rootCount = [];
			this.getWidthHeight();
			for(let i = 0 ; i < keys.length ; i++)
			{
				if(this.tableData[keys[i]].isFocus)
				{ 
					let rootId = keys[i].slice(0,1);
					let col = Number(keys[i].slice(0, 1).charCodeAt(0));
					if(minCol > col)
					{
						minCol = col;
					}
					if(maxCol < col)
					{
						maxCol = col;	
					}
					rootCount.push(rootId);
				}
			}
			// let size = 0;
			let countResult = rootCount.reduce((accu,curr)=> {
				accu.set(curr, (accu.get(curr)||0) +1) ;
				return accu;
			},new Map());
			
			// for (let [key, value] of countResult.entries()) {
			// 	console.log(key + ' : ' + value);
			// 	size++;
			// }
			// console.log(size);
			
			let values = new Set(countResult.values());
			
			
			if((maxCol-minCol+1) != this.tableCol)
			{
				this.$alert("The cell cannot be repeat\n Specify the column as maximum length","Warning","warning");
				return false;
			}
			if(values.size != 1) {
				this.$alert("The cell cannot be repeat\n Specify the column as maximum length","Warning","warning");
				return false;
			}
			// 조건 충족시
			
			//선택한 행 값 및 길이 가져오기
			let focusRow = "";
			let focusList = [];
			for(let i = 0 ; i < keys.length ; i++)
			{
				if(this.tableData[keys[i]].isFocus)
				{
					if(focusList.indexOf(keys[i].slice(1)) < 0){
						focusList.push(keys[i].slice(1));
					}
				}
			}
			focusRow = focusList[focusList.length-1];
			
			//선택한 행 아래 모든 행 데이터 복사
			let repeatArr = [];
			for(let i = 0 ; i < keys.length ; i++)
			{
				let keysnum = parseInt(keys[i].slice(1));
				if(keysnum > parseInt(focusRow))
				{
					repeatArr.push({cellName : keys[i], data : JSON.parse(JSON.stringify(this.tableData[keys[i]]))})
				}
			}
			
			//row height 데이터 복사
			let rowArr = [];
			for(let i = 0 ; i < Object.keys(this.rowInfo).length; i++){
				rowArr.push(JSON.parse(JSON.stringify(this.rowInfo[Object.keys(this.rowInfo)[i]])));
			}
			
			//복사한 데이터 정렬
			if(repeatArr.length != 0){
				repeatArr.sort(function(a,b){
					if(a.row == b.row){
						var x = a.cellName.toLowerCase(), y = b.cellName.toLowerCase();
						return x < y ? -1 : x > y ? 1 : 0;
					}
					return a.row - b.row;
				});
			}
			
			//복사한 데이터 한줄씩 떙겨서 삽입 및 데이터 제거
			// this.deleteData();
			this.$nextTick(function () {
				keys = Object.keys(this.tableData);
				for(let i = 0 ; i < keys.length ; i++)
				{
					if(repeatArr.length != 0){
						for(let j = 0; j < repeatArr.length; j++){
							if(keys[i] == repeatArr[j].cellName){
								let num = parseInt(repeatArr[j].cellName.slice(1)) - focusList.length;
								let subName = keys[i].slice(0, 1) + num.toString();
								this.tableData[subName] = repeatArr[j].data;
								this.tableData[subName].cellName = subName;
								if(Object.keys(this.tableData[keys[i]].field).length != 0){
									this.tableData[subName].field.cellName = subName;
								}
								
								for(let t = 0; t < this.surveyItemList.length; t++){
									if(keys[i] == this.surveyItemList[t].cellName){
										this.surveyItemList[t].cellName = subName;
									}
								}
								
								if(this.tableData[subName].isExpand){
									let rootNum = parseInt(this.tableData[subName].expandRoot.slice(1)) - focusList.length;
									this.tableData[subName].expandRoot = this.tableData[subName].expandRoot.slice(0, 1) + rootNum.toString();
								}
								if(this.tableData[subName].isRepeat){
									let reapetNum = parseInt(this.tableData[subName].repeatRoot.slice(1)) - focusList.length;
									this.tableData[subName].repeatRoot = this.tableData[subName].repeatRoot.slice(0, 1) + reapetNum.toString();
								}
							}
						}
					}
				}
				
				let deleteList = [];
				for(let j = Object.keys(this.rowInfo).length; j > (Object.keys(this.rowInfo).length - focusList.length); j--){
					for(let i = 0; i < keys.length; i++){
						if(parseInt(keys[i].slice(1)) == j){
							deleteList.push(keys[i]);
						}
					}
				}
				
				for(let i = 0; i < deleteList.length; i++){
					this.$delete(this.tableData, deleteList[i]);
				}
				
				this.tableRow -=  focusList.length;
				
				//row height 데이터 셋팅
				this.getWidthHeight();
				for(let i = 0 ; i < Object.keys(this.rowInfo).length; i++){
					if(parseInt(Object.keys(this.rowInfo)[i]) > parseInt(focusRow)){
						this.rowInfo[Object.keys(this.rowInfo)[i]-focusList.length] = rowArr[Object.keys(this.rowInfo)[i]-1];
					}
				}
				
				let delCount = Object.keys(this.rowInfo).length - focusList.length;
				for(let j = Object.keys(this.rowInfo).length; j > delCount; j--){
					this.$delete(this.rowInfo, j);
				}
				this.$nextTick(function () {
					setTimeout(function() {
						this.setRowStyle();
					}.bind(this), 400);
				});
			});
		},
		setColumnStyle() {
			let tableWidth = this.$refs.procedureForm.offsetWidth - 35;
			let cols = document.getElementsByClassName("th-col");
			
			// column-width 100% 초과 방지
			for(let i = 0 ; i < cols.length ; i++)
			{
				if(cols[i].children[0].classList.contains("column-width")) {
					if(Number(this.columnInfo[String.fromCharCode(65 + i)].width) > 100)
					{
						this.columnInfo[String.fromCharCode(65 + i)].width = "100";
					}
				}
			}
			
			for(let i = 0 ; i < cols.length ; i++)
			{
				let id = cols[i].dataset.id;
				let width = Number(this.columnInfo[id].width.replace('%', ''));
				let setWidth = tableWidth * (width / 100);
				cols[i].style.width = setWidth + "px";
			}
		},
		setRowStyle() {
			let rows = document.getElementsByClassName("th-row");
			
			for(let i = 0 ; i < rows.length ; i++)
			{
				let id = rows[i].dataset.id;
				let height = this.rowInfo[id].height;
				rows[i].style.height = height;
			}
		},
		deleteData() {
			let keys = Object.keys(this.tableData);
			for(let i = 0 ; i < keys.length ; i++)
			{
				if(this.tableData[keys[i]].isFocus)
				{
					if(this.tableData[keys[i]].isRepeat)
					{
						this.$alert("Please release the repeat area.","Warning","warning");
						return false;
					}
					if(this.tableData[keys[i]].isExpand)
					{
						let rootId = this.tableData[keys[i]].expandRoot;
						
						let usedIndex = this.usedQuestionNo.indexOf(this.tableData[rootId].field.questionNo);
						if(usedIndex >= 0 && !this.tableData[rootId].isHeader)
						{
							let keyIndex = 0;
							this.surveyItemList.forEach((item, index) => {
								if(rootId == item.cellName){
									keyIndex = index;
								}
							})
							if(keyIndex >= 0){
								let dataTypeCd = this.surveyItemList[usedIndex].fieldList[0].dataTypeCd;
								if(['7','8', '9', '11', '12', '13'].includes(dataTypeCd)){
									this.listIndexReload(this.tableData[keys[i]].field);
								}
								this.surveyItemList.splice(keyIndex, 1);
								if(['7','8', '9', '11', '12', '13'].includes(dataTypeCd)){
									this.listSizeReload(this.tableData[keys[i]].field);
								}
							}
						}
						
						this.$set(this.tableData[rootId], "field", {});
						this.$set(this.tableData[rootId], "text", "");
					}
					else
					{
						let usedIndex = this.usedQuestionNo.indexOf(this.tableData[keys[i]].field.questionNo);
						if(usedIndex >= 0 && !this.tableData[keys[i]].isHeader) 
						{
							let keyIndex = 0;
							this.surveyItemList.forEach((item, index) => {
								if(keys[i] == item.cellName){
									keyIndex = index;
								}
							})
							if(keyIndex >= 0){
								let dataTypeCd = this.surveyItemList[usedIndex].fieldList[0].dataTypeCd;
								if(['7','8', '9', '11', '12', '13'].includes(dataTypeCd)){
									this.listIndexReload(this.tableData[keys[i]].field);
								}
								this.surveyItemList.splice(keyIndex, 1);
								if(['7','8', '9', '11', '12', '13'].includes(dataTypeCd)){
									this.listSizeReload(this.tableData[keys[i]].field);
								}
							}
						}
						
						this.$set(this.tableData[keys[i]], "field", {});
						this.$set(this.tableData[keys[i]], "text", "");
					}
				}
			}
		},
		deleteDefaultData(keys) {
			if(this.tableData[keys].isRepeat)
			{
				this.$alert("Please release the repeat area.","Warning","warning");
				return false;
			}
			if(this.tableData[keys].isExpand)
			{
				let rootId = this.tableData[keys].expandRoot;
				
				let usedIndex = this.usedQuestionNo.indexOf(this.tableData[rootId].field.questionNo);
				if(usedIndex >= 0 && !this.tableData[rootId].isHeader) this.surveyItemList.splice(usedIndex, 1);
				
				this.$set(this.tableData[rootId], "field", {});
				this.$set(this.tableData[rootId], "text", "");
			}
			else
			{
				let usedIndex = this.usedQuestionNo.indexOf(this.tableData[keys].field.questionNo);
				if(usedIndex >= 0 && !this.tableData[keys].isHeader) this.surveyItemList.splice(usedIndex, 1);
				
				this.$set(this.tableData[keys], "field", {});
				this.$set(this.tableData[keys], "text", "");
			}
		},
		pasteCell() {
			let insertField = JSON.parse(JSON.stringify(this.clipBoard));
			if(this.usedQuestionNo.indexOf(insertField.questionNo) >= 0 && !['7','8', '9', '11', '12', '13'].includes(insertField.fieldList[0].dataTypeCd))
			{
				this.$alert("Can't insert same Field.", "Warn", "warning");
				return ;
			}
			
			if(Object.keys(this.clipBoard).length !== 0)
			{
				let keys = Object.keys(this.tableData);
				var focusCnt = 0;
				for(let i = 0 ; i < keys.length ; i++)
				{	
					if(this.tableData[keys[i]].isFocus)
					{
						focusCnt += 1;
						if(focusCnt > 1) {
							this.$alert("Can't insert Field.\nNot allowed for list type Fields.", "Warn", "warning");
							return ;
						}
					}
				}
				for(let i = 0 ; i < keys.length ; i++)
				{
					if(this.tableData[keys[i]].isFocus)
					{
						if(this.usedQuestionNo.indexOf(this.tableData[keys[i]].field.questionNo) >= 0) {
							this.$alert("Can't insert Field.", "Warn", "warning");
							return ;
						}
						if(this.tableData[keys[i]].isExpand)
						{
							let rootId = this.tableData[keys[i]].expandRoot;
							// if(!this.tableData[rootId].isHeader && !this.tableData[rootId].isText && this.usedQuestionNo.indexOf(insertField.questionNo) < 0)
							// {
							// 	insertField.cellName = keys[i];
							// 	this.$set(this.tableData[rootId], "field", insertField);
							// 	this.surveyItemList.push(insertField);
							// }
							if(!this.tableData[rootId].isHeader && !this.tableData[rootId].isText)
							{
								this.defaultField = [];
								let defaultCount = 0;
								let listCount = 0;
								for(let i = 0; i < insertField.fieldList.length; i++)
								{
									// default Value 일 때
									if(insertField.fieldList[i].fieldTypeCd == '12')
									{
										defaultCount += 1;
										// let valueSplit = insertField.fieldList[i].defaultValue.split(";");
										// for(let j = 0; j < valueSplit.length; j++){
										// 	insertField.fieldList[i].defaultValueList.push(valueSplit[j]);
										// }
										this.defaultField.push(insertField.fieldList[i]);
									}
									// list date 일 때
									if(['7','8', '9', '11', '12', '13'].includes(insertField.fieldList[i].dataTypeCd))
									{
										listCount += 1;
									}
								}
								
								insertField.cellName = rootId;
								this.$set(this.tableData[rootId], "field", insertField);
								
								// default Value Popup
								if(defaultCount > 0 && !this.tableData[rootId].isHeader)
								{
									this.defaultCellId = rootId;
									this.isDefaultValue = true;
								}
								
								if(this.tableData[rootId].isHeader)
								{
									this.clipBoard = insertField;
								}
								else
								{
									this.surveyItemList.push(insertField);
									// this.clipBoard = {};
								}
								
								if(listCount > 0 && !this.tableData[rootId].isHeader)
								{
									this.listIndexSet(insertField);
								}
							}
							return ;
						}
						else
						{
							// if(!this.tableData[keys[i]].isHeader && !this.tableData[keys[i]].isText && this.usedQuestionNo.indexOf(insertField.questionNo) < 0)
							// {
							// 	insertField.cellName = keys[i];
							// 	this.$set(this.tableData[keys[i]], "field", insertField);
							// 	this.surveyItemList.push(insertField);
							// }
							if(!this.tableData[keys[i]].isHeader && !this.tableData[keys[i]].isText)
							{
								this.defaultField = [];
								let defaultCount = 0;
								let listCount = 0;
								for(let i = 0; i < insertField.fieldList.length; i++)
								{
									// default Value 일 때
									if(insertField.fieldList[i].fieldTypeCd == '12')
									{
										defaultCount += 1;
										// let valueSplit = insertField.fieldList[i].defaultValue.split(";");
										// for(let j = 0; j < valueSplit.length; j++){
										// 	insertField.fieldList[i].defaultValueList.push(valueSplit[j]);
										// }
										this.defaultField.push(insertField.fieldList[i]);
									}
									// list date 일 때
									if(['7','8', '9', '11', '12', '13'].includes(insertField.fieldList[i].dataTypeCd))
									{
										listCount += 1;
									}
								}
								
								insertField.cellName = keys[i];
								this.$set(this.tableData[keys[i]], "field", insertField);
								
								// default Value Popup
								if(defaultCount > 0 && !this.tableData[keys[i]].isHeader)
								{
									this.defaultCellId = keys[i];
									this.isDefaultValue = true;
								}
								
								if(this.tableData[keys[i]].isHeader)
								{
									this.clipBoard = insertField;
								}
								else
								{
									this.surveyItemList.push(insertField);
									// this.clipBoard = {};
								}
								
								if(listCount > 0 && !this.tableData[keys[i]].isHeader)
								{
									this.listIndexSet(insertField);
								}
							}
						}
					}
				}
			}
		},
		keyMap(event) {
			let isFocusing = false;
			let keys = Object.keys(this.tableData);
			for(let i = 0 ; i < keys.length ; i++)
			{
				if(this.tableData[keys[i]].isFocus)
				{
					isFocusing = true;
					break;
				}
			}
			if(isFocusing)
			{
				if(event.key == 'm' || event.key == 'M') this.mergeCell();
				else if(event.key == 'r' || event.key == 'R') this.revertCell();
				else if(event.key == 'h' || event.key == 'H') this.setHeader();
				else if(event.key == 't' || event.key == 'T') this.setTyping();
				else if(event.key == 'p' || event.key == 'P') this.setRepeat();
				else if(event.key == 'Backspace' || event.key == 'Delete') this.deleteData();
				else if(event.key == 'Enter' || event.code == 'Space') this.pasteCell();
				else if(event.key == 'a' || event.code == 'A') this.addRow();
				else if(event.key == 'd' || event.code == 'D') this.deleteRow();
			}
		},
		dragstart(event, questionItem) {
			this.logger.debug(this, "dragstart()");
			var positionX = event.target.getBoundingClientRect().left + window.pageXOffset;
			var positionY = event.target.getBoundingClientRect().top + window.pageYOffset;
			
			this.dragData.position.top = positionY + "px";
			this.dragData.position.left = positionX + "px";
			this.dragData.position.width = event.target.offsetWidth + "px";
			
			this.dragData.offsetX = event.offsetX;
			this.dragData.offsetY = event.offsetY;
			
			this.dragData.fieldData = questionItem;
			this.dragData.isDrag = true;
		},
		dragging(event) {
			if (this.dragData.isDrag) {
				this.dragData.position.top = event.clientY - this.dragData.offsetY + "px";
				this.dragData.position.left = event.clientX - this.dragData.offsetX + "px";
			}
		},
		draggend() {
			if (this.dragData.isDrag) {
				this.logger.debug(this, "draggend()");

				var getId = this.preview.cellId;
				if(this.preview.isPreview && !this.tableData[getId].isText)
				{
					var insertField = JSON.parse(JSON.stringify(this.dragData.fieldData));
					this.$set(insertField, "cellName", getId);
					if(this.usedQuestionNo.indexOf(insertField.questionNo) >= 0 && !this.tableData[getId].isHeader && !['7','8', '9', '11', '12', '13'].includes(insertField.fieldList[0].dataTypeCd))
					{
						this.$alert("Can't insert same Field.", "Warn", "warning");
					}
					else
					{
						if(this.usedQuestionNo.indexOf(this.tableData[getId].field.questionNo) >= 0 && !this.tableData[getId].isHeader){
							this.$alert("Can't insert Field.", "Warn", "warning");	
						}
						else{
							this.defaultField = [];
							let defaultCount = 0;
							let listCount = 0;
							for(let i = 0; i < insertField.fieldList.length; i++)
							{
								// default Value 일 때
								if(insertField.fieldList[i].fieldTypeCd == '12')
								{
									defaultCount += 1;
									let valueSplit = insertField.fieldList[i].defaultValue.split(";");
									for(let j = 0; j < valueSplit.length; j++){
										insertField.fieldList[i].defaultValueList.push(valueSplit[j]);
									}
									this.defaultField.push(insertField.fieldList[i]);
								}
								// list date 일 때
								if(['7','8', '9', '11', '12', '13'].includes(insertField.fieldList[i].dataTypeCd))
								{
									listCount += 1;
								}
							}
							
							this.$set(this.tableData[getId], "field", insertField);
							
							// default Value Popup
							if(defaultCount > 0 && !this.tableData[getId].isHeader)
							{
								this.defaultCellId = getId;
								this.isDefaultValue = true;
							}
							
							if(this.tableData[getId].isHeader)
							{
								this.clipBoard = insertField;
							}
							else
							{
								this.surveyItemList.push(insertField);
								this.clipBoard = {};
							}
							
							if(listCount > 0 && !this.tableData[getId].isHeader)
							{
								this.listIndexSet(insertField);
							}
						}
					}
				}
				// DragData 초기화
				this.dragData = {
					isDrag: false,
					position: {
						top: "",
						left: "",
					},
					mouseX: "",
					offsetY: "",
					fieldData: {}
				};
				// preview 초기화
				this.hidePreview();
			}
		},
		listIndexSet(field){
			this.logger.debug(this, "listIndexSet()");
			let totalSize = 0;
			for(let i = 0; i < this.surveyItemList.length; i++){
				if(this.surveyItemList[i].questionNo == field.questionNo){
					for(let j = 0; j < this.surveyItemList[i].fieldList.length; j++){
						if(this.surveyItemList[i].fieldList[j].dataTypeCd == field.fieldList[0].dataTypeCd && this.surveyItemList[i].fieldList[j].fieldNo == field.fieldList[0].fieldNo){
							totalSize += 1;
						}
					}
				}
			}
			for(let i = 0; i < this.surveyItemList.length; i++){
				if(this.surveyItemList[i].questionNo == field.questionNo){
					for(let j = 0; j < this.surveyItemList[i].fieldList.length; j++){
						if(this.surveyItemList[i].fieldList[j].dataTypeCd == field.fieldList[0].dataTypeCd && this.surveyItemList[i].fieldList[j].fieldNo == field.fieldList[0].fieldNo){
							this.$set(this.surveyItemList[i], "listSize", totalSize);
						}
					}
				}
			}
			this.$set(field, "listIndex", totalSize);
		},
		listIndexReload(field){
			this.logger.debug(this, "listIndexReload()");
			for(let i = 0; i < this.surveyItemList.length; i++){
				if(this.surveyItemList[i].questionNo == field.questionNo){
					for(let j = 0; j < this.surveyItemList[i].fieldList.length; j++){
						if(this.surveyItemList[i].fieldList[j].dataTypeCd == field.fieldList[0].dataTypeCd && this.surveyItemList[i].fieldList[j].fieldNo == field.fieldList[0].fieldNo){
							if(this.surveyItemList[i].listIndex > field.listIndex){
								let listIndex = JSON.parse(JSON.stringify(this.surveyItemList[i].listIndex))-1;
								this.surveyItemList[i].listIndex = listIndex;
								this.tableData[this.surveyItemList[i].cellName].field.listIndex = listIndex;
							}
						}
					}
				}
			}
		},
		listSizeReload(field){
			this.logger.debug(this, "lisSizeReload()");
			let totalSize = 0;
			for(let i = 0; i < this.surveyItemList.length; i++){
				if(this.surveyItemList[i].questionNo == field.questionNo){
					for(let j = 0; j < this.surveyItemList[i].fieldList.length; j++){
						if(this.surveyItemList[i].fieldList[j].dataTypeCd == field.fieldList[0].dataTypeCd && this.surveyItemList[i].fieldList[j].fieldNo == field.fieldList[0].fieldNo){
							totalSize += 1;
						}
					}
				}
			}
			for(let i = 0; i < this.surveyItemList.length; i++){
				if(this.surveyItemList[i].questionNo == field.questionNo){
					for(let j = 0; j < this.surveyItemList[i].fieldList.length; j++){
						if(this.surveyItemList[i].fieldList[j].dataTypeCd == field.fieldList[0].dataTypeCd && this.surveyItemList[i].fieldList[j].fieldNo == field.fieldList[0].fieldNo){
							this.surveyItemList[i].listSize = totalSize;
						}
					}
				}
			}
		},
		setDefaultField(field, cellId){
			for(let i = 0; i < this.surveyItemList.length; i++){
				for(let j = 0; j < field.length; j++){
					if(this.surveyItemList[i].questionNo == field[j].questionNo && this.tableData[cellId].field.listIndex == this.surveyItemList[i].listIndex)
					{
						for(let l = 0; l < this.surveyItemList[i].fieldList.length; l++){
							if(this.surveyItemList[i].fieldList[l].fieldNo == field[j].fieldNo)
							{
								this.surveyItemList[i].fieldList[l].selectDefault = field[j].selectDefault;
							}
						}
					}
				}
			}
		},
		showPreview(id) {
			this.preview.isPreview = true;
			this.preview.cellId = id;
		},
		hidePreview() {
			this.preview.isPreview = false;
			this.preview.cellId = "";
		},
		getFieldList(id) {
			if(this.preview.isPreview && this.preview.cellId == id)
			{
				return this.dragData.fieldData.fieldList;
			}
			else if(Object.keys(this.tableData[id].field).length !== 0)
			{
				return this.tableData[id].field.fieldList;
			}
			else
			{
				return [];
			}
		},
		getMargin(field) {
			var prefixName = field.prefixName;
			var suffixName = field.suffixName;
			var fieldLayout = field.fieldLayoutCd;

			var topMargin = 0;
			var bottomMargin = 0;
			var leftMargin = 0;
			var rightMargin = 0;

			if (fieldLayout == "1")
			{
				if (prefixName != null && prefixName != "") topMargin = 5;
				if (suffixName != null && suffixName != "") bottomMargin = 5;
			}
			else
			{
				if (prefixName != null && prefixName != "") leftMargin = 10;
				if (suffixName != null && suffixName != "") rightMargin = 10;
			}

			return {
				marginTop: topMargin + "px",
				marginBottom: bottomMargin + "px",
				marginLeft: leftMargin + "px",
				marginRight: rightMargin + "px",
			};
		},
		getGridRowCol(length, cols) {
			var value = parseInt(Number(length) / Number(cols));
			var etc = Number(length) % Number(cols);

			var row = 0;
			var col = cols;
			if (etc == 0) row = value;
			else row = value + 1;

			return {
				gridTemplateRows: "repeat(" + row + ", minmax(36px, auto))",
				gridTemplateColumns: "repeat(" + col + ", auto)",
			};
		},
		loadedImage(field) {
			this.$set(field, 'isLoad', true);
		},
		getWidthHeight() {
			let keys = Object.keys(this.tableData);
			let cols = document.getElementsByClassName("th-col");
			let totalWidth = 0;
			cols.forEach((element) => {
				totalWidth = totalWidth + element.offsetWidth;
			});
			cols.forEach((element) => {
				let columnId = element.dataset.id;
				let percentWidth = Math.round((element.offsetWidth / totalWidth) * 100) + "%";
				this.$set(this.columnInfo, columnId, {width: percentWidth});
			});

			let rootArr = [];
			for(let i = 0 ; i < keys.length ; i++)
			{
				if(this.tableData[keys[i]].isRepeat){
					rootArr.push(this.tableData[keys[i]].repeatRoot);
				}
			}
			let setArr = new Set(rootArr);
			let rowRepeat = [...setArr];

			let rows = document.getElementsByClassName("th-row");
			rows.forEach((element) => {
				let rowId = element.dataset.id;
				let pixelHeight = element.offsetHeight + "px";
				this.$set(this.rowInfo, rowId, {height: pixelHeight, rowRepeat: ""});
				for(let i=0; i < rowRepeat.length; i++){
					if(rowRepeat[i].slice(1) == rowId){
						this.$set(this.rowInfo, rowId, {height: pixelHeight, rowRepeat: rowRepeat[i]});
					}
				}
			});
		},
		doValidation() {
			this.logger.debug(this, "doValidation()");
			this.$validator
				.validateAll()
				.then((result) => {
					this.logger.debug(this, "doValidationResult:" + result);
					this.doDuplicateCheck();
					if(result && !this.isDuplicate)
					{
						// Calculation 조건 입력했는지 검사 해야함
						if(this.surveyItemList.length < 1)
						{
							this.$alert("At least 1 field must be included!","Warning","warning");
							return false;
						}
						else
						{
							this.$confirm("Do you want to register the current procedure?","Question","question").then(() => {
								EventBus.$emit("project-loading", true);
								this.doInsert();
							});
						}
					}
				})
				.catch(() => {
					this.logger.debug(this, "-->" + this.errors.all());
					alert(this.errors.all());
					return false;
				});
		},
		doInsert() {
			this.logger.debug(this, "doInsert()");

			this.surveyItemList = [];
			let keys = Object.keys(this.tableData);
			for(let i = 0 ; i < keys.length ; i++)
			{	
				if(!this.tableData[keys[i]].isHeader){
					if(Object.keys(this.tableData[keys[i]].field).length != 0){
						this.surveyItemList.push(this.tableData[keys[i]].field);
					}
				}
			}

			// Sort Order 입력
			for(let i = 0 ; i < this.surveyItemList.length ; i++)
			{
				this.surveyItemList[i].procQuestionSortOrder = i + 1;
				for(let j = 0 ; j < this.surveyItemList[i].fieldList.length ; j++)
				{
					this.surveyItemList[i].fieldList[j].fieldSortOrder = j + 1;
				}
			}

			// width, height set
			this.getWidthHeight();

			// insert 데이터 전송
			this.items.procQuestionList = this.surveyItemList;
			this.items.tableCol = this.tableCol;
			this.items.tableRow = this.tableRow;

			axios
				.post(this.config.contextRoot + "/procedure/insert.do", this.items)
				.then((response) => {
					if (response.status == 200)
					{
						let sendData = {
							procedureNo: response.data.procedureNo,
							columnInfo: this.columnInfo,
							rowInfo: this.rowInfo,
							tableData: this.tableData
						};
						axios
							.post(this.config.contextRoot + "/procedure/insertTable.do", sendData)
							.then((response) => {
								if (response.status == 200)
								{
									// var url = this.config.contextRoot + "/project/" + this.$route.params.projectNo + "/procedure";
									var url = this.config.contextRoot + "/project/" + this.$route.params.projectNo + "/page";
									if (this.$route.path !== url)
									{
										EventBus.$emit("page-move", this.$route.query.current_page);
										this.$router.push(url);
									}
								}
								else
								{
									alert(response);
								}
							})
							.catch((error) => {
								this.exceptionHandler(this, error);
							});
					}
					else
					{
						alert(response);
					}
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		doCancel() {
			this.logger.debug(this, "doCancel()");
			this.$confirm("Do you want to cancel the OCR template registration?","Question","question").then(() => {
				this.doClose();
			});
		},
		doClose() {
			this.logger.debug(this, "doClose()");
			this.$refs.ocrCreate.style.animation = "fadeOutUp 0.4s ease-in-out both";
			setTimeout(function() {
				// let url = this.config.contextRoot + "/project/" + this.items.projectNo + "/procedure"
				let url = this.config.contextRoot + "/project/" + this.items.projectNo + "/ocr"
				if (this.$route.path !== url)
				{
					EventBus.$emit("project-loading", true);
					this.$router.push(url);
				}
			}.bind(this), 410);
		},
		getAccessList(category){
			axios
				.post(this.config.contextRoot + "/access/getCategoryPrivilegeList.do", {privilegeCategory: category})
				.then((response) => {
					this.accessList = response.data.privilegeList;
					this.accessList.forEach((obj) =>{
						this.workCheck(obj);
					})
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		async workCheck(obj){
			let item = {};
			item = {
				userId: sessionStorage.getItem("userId"),
				projectNo: this.$route.params.projectNo,
				privilegeTypeCd: obj.privilegeTypeCd,
				privilegeCategory: obj.privilegeCategory,
				privilegeName: obj.privilegeName
			}
			obj.isAccess = await this.$accessAuth(item);
		},
		workAccessCheck(name){
			for(let  i = 0; i < this.accessList.length; i++){
				if(this.accessList[i].privilegeName == name){
					return this.accessList[i].isAccess;
				}
			}
		},
		getProjectStateCd() {
			// project 셋팅
			axios
				.post(this.config.contextRoot + "/project/select.do", {projectNo: this.$route.params.projectNo})
				.then((response) => {
					this.projectStateCd = response.data.item.projectStateCd;
				})
				.catch((error) => {
					this.exceptionHandler(this, error);
				});
		},
		handleManualAdjustment() {
			this.isManualAdjustment = !this.isManualAdjustment;
			const widthColumns = document.getElementsByClassName("column-width");
			widthColumns.forEach((element) => {
				if (this.isManualAdjustment) {
					// column-width의 hide 클래스 제거
					element.classList.remove("hide");
				}
				else {
					// column-width의 hide 클래스 추가
					element.classList.add("hide");
				}
			});
		},
		getUrl(file) {
			return new Promise((resolve, reject) => {
				var reader = new FileReader();
				reader.onloadend = (e) => {
					let content = e.target.result;
					resolve(content);
				};
				reader.onerror = (e) => {
					reject(e);
				}
				reader.readAsDataURL(file);
			});
		},
		openUploader() {
			this.logger.debug(this, "openUploader()");
			this.$refs.myfile.click();
		},
		async upload(name, files) {
			try {
				const formData = new FormData();
				
				// 파일 1개 제한
				for (let idx = 0; idx < Math.min(files.length, 1); idx++) {
					formData.append(name, files[idx], files[idx].name);
					this.fileName = files[idx].name;
					this.ocrFile = files[idx];
				}
				
				// 로딩 바 표시
				EventBus.$emit("project-loading", true);
				
				// Step 1: 파일 업로드
				const response = await axios.post(this.config.contextRoot + "/common/file/upload.do", formData);
				
				// 파일 업로드 실패 시
				for (let idx = this.value.length - 1; idx >= 0; idx--) {
					this.value.pop();
				}
				
				// 파일 추가
				for (let idx = 0; idx < response.data.fileList.length; idx++) {
					this.value.push(response.data.fileList[idx]);
				}
				
				// 파일 유형 체크
				let fileType = this.value[0].fileExtensionName.toLowerCase();
				
				if (fileType !== "pdf") {
					throw new Error("Only PDF files are supported.");
				}
				
				// PDF 파일 정보 설정
				const fileData = {
					fileNo: response.data.fileList[0].fileNo,
					fileGroupNo: response.data.fileList[0].fileGroupNo,
					serverFileSaveName: response.data.fileList[0].serverFileSaveName
				};
				
				// Step 2: PDF 이미지 변환
				const pdfResponse = await axios.post(
					this.config.contextRoot + "/common/file/convertPdfToPng.do", 
					fileData
				);
				
				if (pdfResponse.data.error) {
					throw new Error("Documents with more than 1 page are not supported.");
				}
				
				// 이미지 정보 설정
				this.imageInfo.imageUrl = pdfResponse.data.imagePreview;
				this.imageInfo.imageWidth = pdfResponse.data.imageWidth;
				this.imageInfo.imageHeight = pdfResponse.data.imageHeight;
				this.isDrawImage = true;
				
				// Step 3: 나중에 OCR 정보 걷어낼 용도
				const ocrVo = {
					fileList: response.data.fileList,
				}
				const ocrFileResponse = await axios.post(this.config.contextRoot + "/ocr/insertFile.do", ocrVo);
				
				if (ocrFileResponse.error) {
					throw new Error("Error occurred while inserting OCR file.");
				}
				
				this.items.fileNo = ocrFileResponse.data.fileNo;
				
				// Step 3: OCR 정보 추출
				const ocrFormData = new FormData();
				ocrFormData.append("file", this.ocrFile);
				ocrFormData.append("params", JSON.stringify({
					"pages": [], 
					"pre_process": {
						"rotation_90n": false, 
						"rotation_fine": false
					}
				}));
				
				const ocrResponse = await axios.post(
					this.config.contextRoot + "/lomin/api/v1/parsing", 
					ocrFormData, 
					{
						headers: {
							accept: "application/json",
							"Content-Type": "multipart/form-data"
						}
					}
				);
				
				this.logger.debug(this, "OCR Response:", ocrResponse.data);
				
				// OCR 데이터 설정
				this.parsedData = ocrResponse.data;
				console.log(ocrResponse.data);
				
				if (this.parsedData)
				{
					const parsedTexts = this.parsedData.parsed_result[0].texts[0].text;
					console.log(parsedTexts);
				}
				
			} catch (error) {
				if (error.message === "Only PDF files are supported.") {
					this.$alert(error.message, "Warning", "warning");
					this.fileName = "(100MB, Formats:PDF)";
				}
				else if (error.message === "Documents with more than 1 page are not supported.") {
					this.$alert(error.message, "Warning", "warning");
				}
				else {
					this.exceptionHandler(this, error);
				}
			} finally {
				EventBus.$emit("project-loading", false);
			}
		},
        async processDividedFieldOCR(ocrFieldItem) {
			this.logger.debug(this, "processDividedFieldOCR()");
			
			if (!ocrFieldItem || !ocrFieldItem.length || ocrFieldItem.length !== 2) {
				this.logger.error(this, "Invalid divided field structure");
				return;
			}
			
			try {
				EventBus.$emit("project-loading", true);
				
				// A영역과 B영역의 좌표 계산
				const baseArea = ocrFieldItem[0].area;
				if (!baseArea) {
					this.logger.error(this, "No area defined for divided field");
					return;
				}
				
				// A영역 (왼쪽 절반)
				const areaA = {
					x: baseArea.x,
					y: baseArea.y,
					width: baseArea.width / 2,
					height: baseArea.height
				};
				
				// B영역 (오른쪽 절반)
				const areaB = {
					x: baseArea.x + baseArea.width / 2,
					y: baseArea.y,
					width: baseArea.width / 2,
					height: baseArea.height
				};
				
				// A영역 OCR 처리
				const ocrResultA = await this.performOCRForArea(areaA);
				if (ocrResultA) {
					this.$set(ocrFieldItem[0], 'ocrResult', ocrResultA);
				}
				
				// B영역 OCR 처리
				const ocrResultB = await this.performOCRForArea(areaB);
				if (ocrResultB) {
					this.$set(ocrFieldItem[1], 'ocrResult', ocrResultB);
				}
				
				this.logger.debug(this, "Divided OCR Results:", {
					areaA: ocrResultA,
					areaB: ocrResultB
				});
				
			} catch (error) {
				console.error("Error processing divided field OCR:", error);
				this.exceptionHandler(this, error);
			} finally {
				EventBus.$emit("project-loading", false);
			}
		},
		async performOCRForArea(area) {
			this.logger.debug(this, "performOCRForArea()", area);
			
			try {
				// Canvas에서 특정 영역만 추출
				const canvas = this.$refs.drawingCanvas;
				if (!canvas) return null;
				
				const tempCanvas = document.createElement('canvas');
				const tempContext = tempCanvas.getContext('2d');
				
				tempCanvas.width = area.width;
				tempCanvas.height = area.height;
				
				// 원본 캔버스에서 해당 영역만 복사
				tempContext.drawImage(
					canvas,
					area.x, area.y, area.width, area.height,
					0, 0, area.width, area.height
				);
				
				// Canvas를 Blob으로 변환
				return new Promise((resolve) => {
					tempCanvas.toBlob(async (blob) => {
						try {
							// OCR API 호출을 위한 FormData 생성
							const formData = new FormData();
							formData.append("file", blob, "area.png");
							formData.append("params", JSON.stringify({
								"pages": [], 
								"pre_process": {
									"rotation_90n": false, 
									"rotation_fine": false
								}
							}));
							
							const response = await axios.post(
								this.config.contextRoot + "/lomin/api/v1/parsing", 
								formData, 
								{
									headers: {
										accept: "application/json",
										"Content-Type": "multipart/form-data"
									}
								}
							);
							
							if (response.data && response.data.parsed_result && 
								response.data.parsed_result[0] && 
								response.data.parsed_result[0].texts && 
								response.data.parsed_result[0].texts[0]) {
								resolve(response.data.parsed_result[0].texts[0].text);
							} else {
								resolve("");
							}
						} catch (error) {
							console.error("OCR API error:", error);
							resolve("");
						}
					}, 'image/png');
				});
			} catch (error) {
				console.error("Error in performOCRForArea:", error);
				return "";
			}
		},
		openPageSelectModal(ocrFieldType) {
			this.logger.debug(this, "openPageSelectModal()");
			if (!this.isDrawImage) {
				this.$alert("Please upload a PDF file first.", "Warning", "warning");
				return;
			}
			this.ocrFieldType = ocrFieldType;
			this.isOcrPageSelect = true;
		},
		openPageViewModal(pageInfo) {
			this.logger.debug(this, "openPageViewModal()", pageInfo.pageNo);
			this.isOcrPageSelect = false;
			this.selectPage(pageInfo.pageNo);
			if (pageInfo) {
				if (!this.selectedPageList.some(item => item.pageNo === pageInfo.pageNo)) {
					this.selectedPageList.push(pageInfo);
				}
				
				if (this.selectedPageList.length > 0) {
					this.items.pageName = this.selectedPageList
						.map(item => item.pageName)
						.join(',');
				}
			}
		},
		async selectPage(pageNo) {
			this.logger.debug(this, "selectPage()");
			this.paramSigleCreate = {
				pageNo: pageNo,
				pdfYn: 'N',
				ocrFieldType: this.ocrFieldType,
			};
			if (this.ocrFieldType == "check") {
				const response = await axios.post(
					this.config.contextRoot + "/screening/selectProcList.do",
					this.paramSigleCreate
				);
				const tableDataList = response.data.tableDataList;
				
				const isOcrPageType = tableDataList.some(tableData => Object.keys(tableData).some(key => tableData[key].field && tableData[key].field.fieldList.some(field => ["03", "04"].includes(field.fieldTypeCd))));
				
				if (!isOcrPageType) {
					this.$alert("The selected page does not contain any OCR fields.", "Warning", "warning");
					return;
				}
				else {
					this.isOcrPageView = true;
				}
			}
			else {
				this.isOcrPageView = true;
			}
		},
		ocrFieldSave(ocrFieldList) {
			this.logger.debug(this, "ocrFieldSave()");
			if (!this.ocrFieldList) {
				this.ocrFieldList = [];
			}
			const ocrFieldArray = [];
			if (this.ocrFieldType !== "divided") {
				for (const newField of ocrFieldList) {
					const existingIndex = this.ocrFieldList.findIndex(field => field.fieldName === newField.fieldName && field.pageNo === newField.pageNo);
					if (existingIndex !== -1) {
						// this.$alert(`Field "${newField.fieldName}" already exists. \n The existing field will be maintained.`, "Warning", "warning");
						this.$nextTick(() => {
							this.drawExistingAnnotations();
						});
					}
					else {
						this.$set(newField, 'ocrFieldType', this.ocrFieldType);
						const pageInfo = this.selectedPageList.find(item => item.pageNo === newField.pageNo);
						if (pageInfo) {
							newField.pageName = pageInfo.pageName;
						}
						const fieldNo = newField.fieldNo;
						
						if(this.ocrFieldType == "check") {
							axios.post(
								this.config.contextRoot + "/field/select/fieldOptions.do",
								{
									fieldNo: fieldNo,
								}
							).then(response => {
								const fieldOptions = response.data.fieldOptions;
								let options = [];
								let checkOptions = [];
								let checkValues = [];
								if(fieldOptions.fieldTypeCd === '03') {
									checkOptions = fieldOptions.radioOptionsLabel.split(';');
									checkValues = fieldOptions.radioOptionsValue.split(';');
								}
								else if(fieldOptions.fieldTypeCd === '04') {
									checkOptions = fieldOptions.checkboxOptionsLabel.split(';');
									checkValues = fieldOptions.checkboxOptionsValue.split(';');
								}
								else if(fieldOptions.fieldTypeCd === '05') {
									checkOptions = fieldOptions.selectOptionsLabel.split(';');
									checkValues = fieldOptions.selectOptionsValue.split(';');
								}
								checkValues.forEach((checkValue, index) => {
									options.push({
										checkOption: checkOptions[index],
										checkValue: checkValue,
									})
								})
								newField.checkOptions = options;
							}).catch(error => {
								this.exceptionHandler(this, error);
							})
						}
						this.ocrFieldList.push(newField);
					}
				}
			}
			else {
				const ocrField = [];
				ocrFieldList.forEach(field => {
					ocrField.push(field);
				})
				
				for(const field of ocrField) {
					const existingIndex = this.ocrFieldList.findIndex(item => item.fieldName === field.fieldName && item.pageNo === field.pageNo);
					if (existingIndex !== -1) {
						this.$alert(`Field "${field.fieldName}" already exists. \n The existing field will be maintained.`, "Warning", "warning");
						this.$nextTick(() => {
							this.drawExistingAnnotations();
						});
					}
					else {
						this.$set(field, 'ocrFieldType', this.ocrFieldType);
						const pageInfo = this.selectedPageList.find(item => item.pageNo === field.pageNo);
						if (pageInfo) {
							field.pageName = pageInfo.pageName;
						}
						ocrFieldArray.push(field);
					}
				}
				this.ocrFieldList.push(ocrFieldArray);
			}
		},
		deleteOcrField(idx) {
			this.logger.debug(this, "deleteOcrField()", idx);
			
			const field = this.ocrFieldList[idx];
			if (field) {
				const pageInfo = this.selectedPageList.find(item => item.pageNo === field.pageNo);
				if (pageInfo) {
					this.selectedPageList.splice(this.selectedPageList.indexOf(pageInfo), 1);
					
					this.items.pageName = this.selectedPageList
						.map(item => item.pageName)
						.join(',');
				}
			}
			
			if (this.ocrFieldList && this.ocrFieldList.length > 0) {
				this.ocrFieldList.splice(idx, 1);
			}
			
			this.deselectOcrField();
		},
		updateFieldName(ocrFieldItem) {
			this.logger.debug(this, "updateFieldName()", ocrFieldItem);
			const index = this.ocrFieldList.findIndex(field => field.fieldName === ocrFieldItem.fieldName);
			if (index !== -1) {
				this.$set(this.ocrFieldList, index, ocrFieldItem);
			}
		},
		initializeCanvas() {
			this.logger.debug(this, "initializeCanvas()");
			setTimeout(() => {
				const canvas = this.$refs.drawingCanvas;
				const container = this.$refs.imageViewer;
				if (canvas && container) {
					const img = new window.Image();
					img.onload = () => {
						canvas.width = this.imageInfo.imageWidth;
						canvas.height = this.imageInfo.imageHeight;
						this.imageObj = img;
						this.drawImageAndAnnotations();
					}
					img.src = this.imageInfo.imageUrl;
				}
			}, 500);
		},
		drawImageAndAnnotations() {
			this.logger.debug(this, "drawImageAndAnnotations()");
			const canvas = this.$refs.drawingCanvas;
			if (!canvas || !this.imageObj) return;
			const ctx = canvas.getContext('2d');
			ctx.clearRect(0, 0, canvas.width, canvas.height);
			ctx.drawImage(this.imageObj, 0, 0, canvas.width, canvas.height);
		},
		selectOcrField(ocrFieldItem) {
			this.logger.debug(this, "selectOcrField()", ocrFieldItem);
			
			if (this.selectedOcrField && this.selectedOcrField.fieldName === ocrFieldItem.fieldName && this.selectedOcrField.pageNo === ocrFieldItem.pageNo) {
				if (this.isDrawingMode) {
					this.cancelDrawing();
					return;
				}
			}
			
			if (ocrFieldItem.checkOptions) {
				if (ocrFieldItem.checkValue == '') {
					this.$alert("Please select a value for \"" + ocrFieldItem.fieldName + "\"", "Info", "info");
					return;
				}
			}
			
			this.selectedOcrField = ocrFieldItem;
			
			if(ocrFieldItem.area) {
				if (this.selectedOcrField.isFocused && this.selectedOcrField.fieldName === ocrFieldItem.fieldName && this.selectedOcrField.pageNo === ocrFieldItem.pageNo) {
					this.deselectOcrField();
					return;
				}
				else {
					this.offFocus();
					this.focusOnArea(ocrFieldItem);
				}
			}
			else {
				this.isDrawingMode = true;
				this.toolsPosition = {
					x: 0,
					y: 0,
					visible: true
				}
				this.$alert(`Please draw a rectangle on the PDF for "${ocrFieldItem.fieldName}"`, "Info", "info");
			}
		},
		selectOcrDividedField(ocrFieldList) {
			this.logger.debug(this, "selectOcrDividedField()", ocrFieldList);
			
			for(const ocrFieldItem of ocrFieldList) {
				if (this.selectedOcrField && this.selectedOcrField.fieldName === ocrFieldItem.fieldName && this.selectedOcrField.pageNo === ocrFieldItem.pageNo) {
					if(this.isDrawingMode) {
						this.cancelDrawing();
						return;
					}
				}
			}
			
			this.selectedOcrField = ocrFieldList;
			
			for(const ocrFieldItem of ocrFieldList) {
				if(ocrFieldItem.area) {
					if (this.selectedOcrField.isFocused && this.selectedOcrField.fieldName === ocrFieldItem.fieldName && this.selectedOcrField.pageNo === ocrFieldItem.pageNo) {
						this.deselectOcrField();
						return;
					}
					else {
						this.offFocus();
						this.focusOnArea(ocrFieldItem);
					}
				}
				else {
					this.isDrawingMode = true;
					this.toolsPosition = {
						x: 0,
						y: 0,
						visible: true
					}
				}
			}
			
			this.$alert(`Please draw a rectangle on the PDF for "${ocrFieldList[0].fieldName} / ${ocrFieldList[1].fieldName}"`, "Info", "info");
		},
		cancelDrawing() {
			const canvas = this.$refs.drawingCanvas;
			const context = canvas.getContext('2d');
			context.clearRect(0, 0, canvas.width, canvas.height);
			
			this.isDrawingMode = false;
			this.rectangle = null;
			
			this.drawExistingAnnotations();
		},
		focusOnArea(ocrFieldItem) {
			if (!this.$refs.drawingCanvas) {
				this.initializeCanvas();
				return;
			}
			
			const ocrFieldType = ocrFieldItem.ocrFieldType ? ocrFieldItem.ocrFieldType : ocrFieldItem[0].ocrFieldType;
			this.isDrawingMode = false;
			this.isEditMode = false;
			if (ocrFieldType !== "divided") {
				this.selectedOcrField.isFocused = true;
			}
			else {
				const selectedOcrFieldList = this.selectedOcrField;
				for (const ocrFieldItem of selectedOcrFieldList) {
					ocrFieldItem.isFocused = true;
				}
			}
			
			this.drawExistingAnnotations();
			if (!ocrFieldItem.area) return;
		},
		drawExistingAnnotations() {
			this.logger.debug(this, "drawExistingAnnotations()");
			const canvas = this.$refs.drawingCanvas;
			if (!canvas || !this.imageObj) return;
			
			const context = canvas.getContext('2d');
			context.clearRect(0, 0, canvas.width, canvas.height);
			context.drawImage(this.imageObj, 0, 0, canvas.width, canvas.height);
			
			if (this.ocrFieldList) {
				this.ocrFieldList.forEach((field, index) => {
					if(field.ocrFieldType){
						if (field.area) {
							const isActive = this.selectedOcrField && this.selectedOcrField.fieldName === field.fieldName && this.selectedOcrField.pageNo === field.pageNo;
							const { x, y, width, height } = field.area;
							if (field.ocrFieldType === 'square') {
								context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
								context.lineWidth = 2;
								context.strokeRect(x, y, width, height);
								context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
								context.fillRect(x, y, width, height);
								context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.7)' : 'rgba(43, 173, 224, 0.7)';
								context.fillRect(x, y - 50, field.fieldName.length * 40, 50);
								context.font = '24px Pretendard';
								context.fillStyle = 'rgba(255, 255, 255, 0.8)';
								context.fillText(field.fieldName, x + 15, y - 20);
							}
							else if (field.ocrFieldType === 'check') {
								context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
								context.lineWidth = 2;
								context.strokeRect(x, y, width, height);
								context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
								context.fillRect(x, y, width, height);
								
								const checkWidth = width * 0.7;
								const checkHeight = height * 0.5;
								const checkX = x + width * 0.15;
								const checkY = y + height * 0.5;
								
								context.beginPath();
								context.moveTo(checkX, checkY);
								context.lineTo(checkX + checkWidth * 0.3, checkY + checkHeight * 0.8);
								context.lineTo(checkX + checkWidth, checkY - checkHeight * 0.8);
								context.lineWidth = 4;
								context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.9)' : 'rgba(43, 173, 224, 0.9)';
								context.stroke();
								
								context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.7)' : 'rgba(43, 173, 224, 0.7)';
								context.fillRect(x, y - 50, field.fieldName.length * 40, 50);
								context.font = '24px Pretendard';
								context.fillStyle = 'rgba(255, 255, 255, 0.8)';
								context.fillText(field.fieldName, x + 15, y - 20);
							}
						}
					}
					else {
						const ocrFieldList = this.ocrFieldList[index];
						for (let idx = 0; idx < 1; idx++) {
							const ocrFieldItem = ocrFieldList[idx];
							if (ocrFieldItem.area) {
								const isActive = (this.selectedOcrField && this.selectedOcrField.length > 1) && this.selectedOcrField[idx].fieldName === ocrFieldItem.fieldName && this.selectedOcrField[idx].pageNo === ocrFieldItem.pageNo;
								const { x, y, width, height } = ocrFieldItem.area;
								
								context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
								context.lineWidth = 2;
								context.strokeRect(x, y, width, height);
								context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
								context.fillRect(x, y, width, height);
								
								context.beginPath();
								context.moveTo(x + width / 2, y);
								context.lineTo(x + width / 2, y + height);
								context.strokeStyle = isActive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(43, 173, 224, 0.3)';
								context.lineWidth = 2;
								context.stroke();
								
								context.font = '24px Pretendard bold';
								context.fillStyle = 'rgba(43, 173, 224, 0.9)';
								context.textAlign = 'center';
								context.textBaseline = 'middle';
								context.fillText('A', x + width / 4, y + height / 2);
								context.fillText('B', x + (width * 3) / 4, y + height / 2);
								
								// divided 필드의 A/B 필드명 모두 표시
								const fieldNameA = ocrFieldList[0].fieldName;
								const fieldNameB = ocrFieldList[1].fieldName;
								const labelText = `${fieldNameA} / ${fieldNameB}`;

								context.fillStyle = isActive ? 'rgba(255, 0, 0, 0.7)' : 'rgba(43, 173, 224, 0.7)';
								context.fillRect(x, y - 50, labelText.length * 20, 50);
								context.font = '24px Pretendard';
								context.fillStyle = 'rgba(255, 255, 255, 0.8)';
								context.textAlign = 'left';
								context.fillText(labelText, x + 15, y - 20);
							}
						}
					}
				});
			}
		},
		deselectOcrField() {
			if (this.isDrawingMode) {
				this.cancelDrawing();
			}
			
			this.offFocus();
			this.selectedOcrField.isFocused = false;
			this.selectedOcrField = null;
			this.toolsPosition = {
				x: 0,
				y: 0,
				visible: false
			}
			this.drawExistingAnnotations();
		},
		offFocus() {
			this.logger.debug(this, "offFocus()");
			this.ocrFieldList.forEach((field) => {
				if (field.isFocused) {
					field.isFocused = false;
				}
			});
		},
		startDrawing(event) {
			if (!this.selectedOcrField || !this.isDrawingMode) return;
			
			this.isDrawing = true;
			const canvas = this.$refs.drawingCanvas;
			const rect = canvas.getBoundingClientRect();
			
			const scaleX = canvas.width / rect.width;
			const scaleY = canvas.height / rect.height;
			
			this.startX = (event.clientX - rect.left) * scaleX;
			this.startY = (event.clientY - rect.top) * scaleY;
			
			this.rectangle = {
				x: this.startX,
				y: this.startY, 
				width: 0, 
				height: 0,
				type: this.selectedOcrField.ocrFieldType ? this.selectedOcrField.ocrFieldType : this.selectedOcrField[0].ocrFieldType // 타입 정보 저장
			};
		},
		draw(event) {
			if (!this.isDrawing || !this.isDrawingMode || !this.selectedOcrField || !this.rectangle) return;
			
			const canvas = this.$refs.drawingCanvas;
			const context = canvas.getContext('2d');
			const rect = canvas.getBoundingClientRect();
			
			const scaleX = canvas.width / rect.width;
			const scaleY = canvas.height / rect.height;
			
			const currentX = (event.clientX - rect.left) * scaleX;
			const currentY = (event.clientY - rect.top) * scaleY;
			
			context.clearRect(0, 0, canvas.width, canvas.height);
			this.drawExistingAnnotations();
			
			this.rectangle.width = currentX - this.startX;
			this.rectangle.height = currentY - this.startY;
			
			this.toolsPosition = {
				x: (this.rectangle.x + this.rectangle.width) / scaleX + 80,
				y: (this.rectangle.y + this.rectangle.height / 2) / scaleY,
				visible: true
			};
			
			// 저장된 타입에 따라 그리기 (미리 저장된 타입을 사용하여 분기 최소화)
			switch (this.rectangle.type) {
				case 'square':
					this.drawSquareShape(context);
					break;
				case 'divided':
					this.drawDividedShape(context);
					break;
				case 'check':
					this.drawCheckShape(context);
					break;
				default:
					this.drawSquareShape(context);
			}
		},
		drawSquareShape(context) {
			context.strokeStyle = 'rgba(43, 173, 224, 0.8)';
			context.lineWidth = 2;
			context.strokeRect(this.rectangle.x, this.rectangle.y, this.rectangle.width, this.rectangle.height);
			context.fillStyle = 'rgba(43, 173, 224, 0.3)';
			context.fillRect(this.rectangle.x, this.rectangle.y, this.rectangle.width, this.rectangle.height);
			
			// 필드 이름 라벨
			context.fillStyle = 'rgba(43, 173, 224, 0.7)';
			context.fillRect(this.rectangle.x, this.rectangle.y-50, this.selectedOcrField.fieldName.length * 40, 50);
			context.font = '24px Pretendard';
			context.fillStyle = 'rgba(255, 255, 255, 0.8)';
			context.fillText(this.selectedOcrField.fieldName, this.rectangle.x + 15, this.rectangle.y - 20);
		},
		drawDividedShape(context) {
			// 전체 사각형 그리기
			context.strokeStyle = 'rgba(43, 173, 224, 0.8)';
			context.lineWidth = 2;
			context.strokeRect(this.rectangle.x, this.rectangle.y, this.rectangle.width, this.rectangle.height);
			context.fillStyle = 'rgba(43, 173, 224, 0.3)';
			context.fillRect(this.rectangle.x, this.rectangle.y, this.rectangle.width, this.rectangle.height);
			
			// 중앙 분리선 그리기
			context.beginPath();
			context.moveTo(this.rectangle.x + this.rectangle.width / 2, this.rectangle.y);
			context.lineTo(this.rectangle.x + this.rectangle.width / 2, this.rectangle.y + this.rectangle.height);
			context.strokeStyle = 'rgba(43, 173, 224, 0.8)';
			context.lineWidth = 2;
			context.stroke();
			
			// 왼쪽 구역에 "A" 텍스트 추가
			context.font = '24px Pretendard bold';
			context.fillStyle = 'rgba(43, 173, 224, 0.9)';
			context.textAlign = 'center';
			context.textBaseline = 'middle';
			context.fillText('A', this.rectangle.x + this.rectangle.width / 4, this.rectangle.y + this.rectangle.height / 2);
			
			// 오른쪽 구역에 "B" 텍스트 추가
			context.fillText('B', this.rectangle.x + (this.rectangle.width * 3) / 4, this.rectangle.y + this.rectangle.height / 2);
			
			// 필드 이름 라벨 추가 (A/B 필드명 모두 표시)
			const fieldNameA = this.selectedOcrField[0].fieldName;
			const fieldNameB = this.selectedOcrField[1].fieldName;
			const labelText = `${fieldNameA} / ${fieldNameB}`;

			context.fillStyle = 'rgba(43, 173, 224, 0.7)';
			context.fillRect(this.rectangle.x, this.rectangle.y - 50, labelText.length * 20, 50);
			context.font = '24px Pretendard';
			context.fillStyle = 'rgba(255, 255, 255, 0.8)';
			context.textAlign = 'left';
			context.fillText(labelText, this.rectangle.x + 15, this.rectangle.y - 20);
		},
		drawCheckShape(context) {
			// 사각형 그리기
			context.strokeStyle = 'rgba(43, 173, 224, 0.8)';
			context.lineWidth = 2;
			context.strokeRect(this.rectangle.x, this.rectangle.y, this.rectangle.width, this.rectangle.height);
			context.fillStyle = 'rgba(43, 173, 224, 0.3)';
			context.fillRect(this.rectangle.x, this.rectangle.y, this.rectangle.width, this.rectangle.height);
			
			// 체크 표시 그리기
			const checkWidth = this.rectangle.width * 0.7;
			const checkHeight = this.rectangle.height * 0.5;
			const checkX = this.rectangle.x + this.rectangle.width * 0.15;
			const checkY = this.rectangle.y + this.rectangle.height * 0.5;
			
			context.beginPath();
			context.moveTo(checkX, checkY);
			context.lineTo(checkX + checkWidth * 0.3, checkY + checkHeight * 0.8);
			context.lineTo(checkX + checkWidth, checkY - checkHeight * 0.8);
			context.lineWidth = 4;
			context.strokeStyle = 'rgba(43, 173, 224, 0.9)';
			context.stroke();
			
			// 필드 이름 라벨
			context.fillStyle = 'rgba(43, 173, 224, 0.7)';
			context.fillRect(this.rectangle.x, this.rectangle.y-50, this.selectedOcrField.fieldName.length * 40, 50);
			context.font = '24px Pretendard';
			context.fillStyle = 'rgba(255, 255, 255, 0.8)';
			context.fillText(this.selectedOcrField.fieldName, this.rectangle.x + 15, this.rectangle.y - 20);
		},
		stopDrawing() {
			if (!this.isDrawing || !this.isDrawingMode) return;
			this.isDrawing = false;
		},
		saveDrawing() {
			if (!this.selectedOcrField || !this.rectangle) return;
			
			// 픽셀 -> OCR 좌표 변환
			const canvas = this.$refs.drawingCanvas;
			
			const x1 = this.rectangle.x / canvas.width;
			const y1 = this.rectangle.y / canvas.height;
			const x2 = (this.rectangle.x + this.rectangle.width) / canvas.width;
			const y2 = (this.rectangle.y + this.rectangle.height) / canvas.height;
			
			if (this.selectedOcrField.ocrFieldType) {
				this.$set(this.selectedOcrField, 'position', [x1, y1, x2, y2]);
				this.$set(this.selectedOcrField, 'area', {
					x: this.rectangle.x,
					y: this.rectangle.y,
					width: this.rectangle.width,
					height: this.rectangle.height
				});
			}
			else {
				const selectedOcrField = this.selectedOcrField;
				for(const ocrFieldItem of selectedOcrField) {
					this.$set(ocrFieldItem, 'position', [x1, y1, x2, y2]);
					this.$set(ocrFieldItem, 'area', {
						x: this.rectangle.x,
						y: this.rectangle.y,
						width: this.rectangle.width,
						height: this.rectangle.height
					});
				}
			}
			
			this.drawExistingAnnotations();
			
			if (this.selectedOcrField.ocrFieldType) {
				this.$alert(`Area saved for "${this.selectedOcrField.fieldName}"`, "Success", "success");
			}
			else {
				this.$alert(`Area saved for "${this.selectedOcrField[0].fieldName} / ${this.selectedOcrField[1].fieldName}"`, "Success", "success");
			}
			this.deselectOcrField();
		},
		editAnnotation(ocrFieldItem) {
			this.logger.debug(this, "editAnnotation()", ocrFieldItem);
			this.selectedOcrField = ocrFieldItem;
			this.isDrawingMode = true;
			this.isEditMode = true;
			
			this.toolsPosition = {
				x: 0,
				y: 0,
				visible: true
			}
			
			this.drawExistingAnnotations();

			// divided 필드인지 확인하여 적절한 메시지 표시
			if (ocrFieldItem.ocrFieldType) {
				// 단일 필드 (square, check 등)
				this.$alert(`Please redraw the area for "${ocrFieldItem.fieldName}"`, "Info", "info");
			} else {
				// divided 필드 (배열 형태)
				const fieldNameA = ocrFieldItem[0].fieldName;
				const fieldNameB = ocrFieldItem[1].fieldName;
				this.$alert(`Please redraw the area for "${fieldNameA} / ${fieldNameB}"`, "Info", "info");
			}
		},
		handleEscKey(event) {
			if (event.key === 'Escape' && this.isDrawingMode) {
				this.deselectOcrField();
			}
		},
		async doSave() {
			this.logger.debug(this, "doSave()");
			EventBus.$emit("project-loading", true);
			const formData = new FormData();
			
			// ocr template 기본 정보 검증
			if (!this.items.ocrName || !this.items.projectNo || !this.items.description) {
				const missingField = !this.items.ocrName ? "OCR name" : 
									 !this.items.projectNo ? "project" : "description";
				this.$alert(`Please enter the ${missingField}.`, "Warning", "warning");
				EventBus.$emit("project-loading", false);
				return;
			}
			
			// repeatCnt 임의 설정
			this.items.repeatCnt = 1;
			
			// ocr template name 중복 체크
			this.doDuplicateCheck();
			
			if (this.isDuplicate) {
				this.$alert("The OCR name already exists.", "Warning", "warning");
				EventBus.$emit("project-loading", false);
				return;
			}
			
			// ocrFieldList 검증
			if (this.ocrFieldList.length === 0) {
				this.$alert("Please add at least one field.", "Warning", "warning");
				EventBus.$emit("project-loading", false);
				return;
			}
			
			// 드로잉 검증
			if (this.isDrawingMode) {
				this.$alert("Please finish drawing before saving.", "Warning", "warning");
				EventBus.$emit("project-loading", false);
				return;
			}
			
			formData.append("projectNo", this.items.projectNo);
			formData.append("ocrName", this.items.ocrName);
			formData.append("description", this.items.description);
			formData.append("repeatCnt", this.items.repeatCnt);
			formData.append("fileNo", this.items.fileNo);
			
			let ocrData = {
				projectNo: this.items.projectNo,
				ocrName: this.items.ocrName,
				description: this.items.description,
				repeatCnt: this.items.repeatCnt,
				fileNo: this.items.fileNo,
			};
			
			try {
				// Step 1: OCR 필드 기본 정보 저장
				const ocrResponse = await axios.post(this.config.contextRoot + "/ocr/insert.do", ocrData);
				
				if (ocrResponse.data.error) {
					throw new Error("Failed to save OCR template data");
				}
				
				const ocrNo = ocrResponse.data.ocrNo;
				
				// Step 2: Save OCR fields
				for (const field of this.ocrFieldList) {
					// 단일 필드 (square, check) 처리
					if (field.ocrFieldType) {
						// 단일 필드의 area와 position이 정의되어 있는지 확인
						if (!field.area || !field.position) {
							throw new Error(`Please draw area for field "${field.fieldName}"`);
						}

						const fieldData = {
							ocrNo: ocrNo,
							fieldNo: field.fieldNo,
							fieldName: field.fieldName,
							fieldType: field.fieldType || field.ocrFieldType,
							pageNo: field.pageNo,
							questionNo: field.questionNo,
							procFieldNo: field.procFieldNo,
							procQuestionNo: field.procQuestionNo,
							areaX: field.area.x,
							areaY: field.area.y,
							areaWidth: field.area.width,
							areaHeight: field.area.height,
							topLeftX: field.position[0],
							topLeftY: field.position[1],
							bottomRightX: field.position[2],
							bottomRightY: field.position[3],
							checkValue: field.checkValue,
						};
						await axios.post(this.config.contextRoot + "/ocr/field/insert.do", fieldData);
					}
					// divided 필드 (배열 형태) 처리
					else if (Array.isArray(field) && field.length > 0 && field[0].ocrFieldType === 'divided') {
						for (const ocrFieldItem of field) {
							// divided 필드의 area와 position이 정의되어 있는지 확인
							if (!ocrFieldItem.area || !ocrFieldItem.position) {
								throw new Error(`Please draw area for divided field "${ocrFieldItem.fieldName}"`);
							}
							
							const fieldData = {
								ocrNo: ocrNo,
								fieldNo: ocrFieldItem.fieldNo,
								fieldName: ocrFieldItem.fieldName,
								fieldType: ocrFieldItem.fieldType || ocrFieldItem.ocrFieldType,
								pageNo: ocrFieldItem.pageNo,
								questionNo: ocrFieldItem.questionNo,
								procFieldNo: ocrFieldItem.procFieldNo,
								procQuestionNo: ocrFieldItem.procQuestionNo,
								areaX: ocrFieldItem.area.x,
								areaY: ocrFieldItem.area.y,
								areaWidth: ocrFieldItem.area.width,
								areaHeight: ocrFieldItem.area.height,
								topLeftX: ocrFieldItem.position[0],
								topLeftY: ocrFieldItem.position[1],
								bottomRightX: ocrFieldItem.position[2],
								bottomRightY: ocrFieldItem.position[3],
								checkValue: ocrFieldItem.checkValue,
							};
							await axios.post(this.config.contextRoot + "/ocr/field/insert.do", fieldData);
						}
					}
					// 예상치 못한 필드 구조인 경우
					else {
						console.warn("Unknown field structure:", field);
						throw new Error("Invalid field structure detected");
					}
				}
				
				this.$alert("OCR template saved successfully", "Success", "success");
				
				// Navigate back to OCR list page
				setTimeout(() => {
					let url = this.config.contextRoot + "/project/" + this.items.projectNo + "/ocr";
					this.$router.push(url);
				}, 500);
				
			} catch (error) {
				this.$alert(error.message || "Failed to save OCR template", "Error", "error");
				console.error(error);
			} finally {
				EventBus.$emit("project-loading", false);
			}
		},
	}
};
</script>

<style scoped>
.survey-contents-contaner {
	display: grid;
	grid-template-columns: 1fr;
	grid-auto-flow: auto;
	row-gap: 0;
	position: absolute;
	top: 171px;
	left: calc(19% + 155px);
	width: calc(81% - 260px);
	height: calc(100% - 171px);
	padding: 0 0 50px 0;
	overflow-x: hidden;
	overflow-y: scroll;
	z-index: 50;
} 

.control-box {
	display: flex;
	align-items: center;
	width: 100%;
	height: 35px;
	padding: 0 0 0 34px;
	background-color: #eee;
}

.table-set > input[type=number] {
	width: calc(50% - 15px);
}

.table-set > span {
	width: 30px;
	text-align: center;
}

.procedure-table {
	width: 100%;
	border-collapse: separate;
	border-spacing: 0;
}

.procedure-table:focus {
	outline: none;
}

.procedure-table tr {
	-moz-user-select: none;
	-webkit-user-select: none;
	user-select: none;
}

.procedure-table thead {
	position: sticky;
	top: 0px;
	z-index: 55;
}

.procedure-table thead th {
	position: relative;
	min-width: 30px;
	height: 35px;
	overflow-x: auto;
	resize: horizontal;
	-moz-user-select: none;
	-webkit-user-select: none;
	user-select: none;
}

.procedure-table thead tr th:first-child {
	width: 35px;
	resize: none;
	-webkit-user-select: none;
}

.procedure-table tbody th {
	width: 35px;
	position: relative;
	height: 50px;
	min-height: 50px;
	overflow-y: auto;
	resize: vertical;
	-moz-user-select: none;
	-webkit-user-select: none;
	user-select: none;
}

.procedure-table th {
	border: 1px solid #ccc;
	background-color: #eee;
	font-weight: 600;
	font-size: 10pt;
	color: #000;
}

.procedure-table td {
	position: relative;
	border: 1px solid #ccc;
	background-color: #fff;
	font-size: 10pt;
	word-break: keep-all;
}

.procedure-table td > input[type=text] {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	padding: 0 10px;
	border: none;
	background-color: unset;
	font-weight: inherit;
	font-size: inherit;
	text-align: inherit;
}

.procedure-table .focus-celltype {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	padding: 5px;
	font-family: cursive;
	font-weight: 500;
	font-size: 9pt;
	text-align: right;
	overflow: hidden;
	z-index: 5;
	opacity: 0.6;
}
.procedure-table .focus-celltype .celltype-repeat {
	display: inline-block;
	margin: 0 5px 0 0;
	padding: 2px 5px;
	background-color: #fc9e12;
	border-radius: 3px;
	color: rgb(255, 255, 255);
}

.procedure-table .focus-celltype .celltype-header {
	display: inline-block;
	margin: 0 5px 0 0;
	padding: 2px 5px;
	background-color: #2bade0;
	border-radius: 3px;
	color: #fff;
}

.procedure-table .focus-celltype .celltype-text {
	display: inline-block;
	padding: 2px 5px;
	background-color: #9ecc5a;
	border-radius: 3px;
	color: #fff;
}

.procedure-table .focus-celltype .celltype-data {
	display: inline-block;
	padding: 2px 5px;
	background-color: #cc5a5a;
	border-radius: 3px;
	color: #fff;
}
.procedure-table .focus-celltype .listIndex-data {
	display: inline-block;
	padding: 2px 5px;
	background-color: #8808af;
	margin-left: 3px;
	border-radius: 3px;
	color: #fff;
}

.unfocus-text,
.table-head {
	display: flex;
	justify-content: inherit;
	align-items: center;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	padding: 0 10px;
	font-weight: inherit;
	font-size: 10pt;
	overflow: hidden;
	z-index: 15;
}

.table-data {
	display: flex;
	align-items: center;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	padding: 0 10px;
	font-weight: inherit;
	font-size: 10pt;
	overflow: hidden;
	z-index: 1;
}

.survey-field-list {
	width: 100%;
	font-weight: 600 !important;
	font-size: 10pt !important;
	color: #666;
	overflow-y: visible;
}

.survey-field-vtype,
.survey-field-htype {
	max-width: 100%;
	font-weight: 400 !important;
}

.input-crud-error::placeholder {
	color: rgb(224, 91, 91);
}
.date-picker{
	position: relative;
}
.hide {
	display: none;
}
.survey-name-ocr{
	display: grid;
	grid-template-columns: 200px 1fr 200px 1fr;
	grid-template-rows: 1fr 1fr 1fr;
	top: 30px;
	width: 100%;
	height: 136px;
	border-top: 1px solid #ccc;
}
.survey-center-ocr{
	display: flex;
	min-height: calc(100% - 171px);
	height: calc(100% - 171px);
	margin-top: 30px;
}
.survey-left-ocr{
	width: 75%;
	height: 100%;
	border: 1px solid #ccc;
	border-right: none;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: #E4E4E4;
	color: #999;
	font-weight: bold;
	font-size: 25px;
	cursor: pointer;
}
.survey-right-ocr{
	width: 25%;
	height: 100%;
	border: 1px solid #ccc;
}
.field-spec-header{
	width: 100%;
	height: 50px;
	background-color: #FAFAFA;
	display: flex;
	align-items: center;
	padding-left: 20px;
	color: #2BADE0;
	font-weight: bold;
	font-size: 13px;
	border-bottom: 1px solid #ccc;
}
.field-spec-sub{
	width: 100%;
	height: 50px;
	display: flex;
	align-items: center;
	padding-left: 20px;
	font-weight: bold;
	font-size: 13px;
	color: #999999;
}
.field-type-list{
	display: flex;
	justify-content: center;
	column-gap: 10px;
	padding: 0 10px 0 10px;
}
.field-type-btn{
	flex: 1;
	height: 70px;
	background-color: #FAFAFA;
	border-radius: 4px;
	border: #E5E8EB 1px solid;
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
	cursor: pointer;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	row-gap: 6.5px;
	font-size: 12px;
	font-weight: bold;
	color: #CCCCCC;
}
.field-type-btn:hover{
	border: #2BADE0 1px solid;
	box-shadow: none;
	color: #2BADE0;
}
.field-type-img-1{
	width: 80%;
	height: 24px;
	background-color: #fff;
	/* border: 1px solid #707070; */
	display: flex;
	justify-content: center;
	align-items: center;
	color: #707070;
}
.field-type-img-2{
	width: 80%;
	height: 24px;
	background-color: #fff;
	border: 1px solid #707070;
	display: flex;
}
.field-type-img-3{
	width: 40%;
	height: 24px;
	background-color: #fff;
	border: 1px solid #707070;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #707070;
}
.field-type-img-sub{
	width: 50%;
	height: 100%;
	background-color: #fff;
	border: 1px solid #707070;
	display: flex;
	justify-content: center;
	align-items: center;
	color: #707070;
}
.field-type-img-sub:first-child{
	border-right: none;
}
.ocr-field-list {
	width: 100%;
	display: grid;
	gap: 20px;
	margin: 20px 0;
	padding: 0 10px 0 10px;
	max-height: calc(100% - 200px);
	overflow-y: auto;
}
.ocr-field-list::-webkit-scrollbar {
	width: 20px;
}

.ocr-field-list::-webkit-scrollbar-thumb {
	float: right;
	border: 7px solid transparent;
	border-radius: 20px;
	background: linear-gradient(to top, #2bade0, #9ecc5a);
	background-clip: padding-box;
}

.ocr-field-list::-webkit-scrollbar-track {
	background-color: #fff;
}
.ocr-field-item {
	border: 1px solid #ccc;
	border-radius: 4px;
	background-color: #f4f4f4;
}
.ocr-field-item:hover {
	border-color: #2BADE0;
	box-shadow: 0 2px 5px rgba(0,0,0,0.1);
	cursor: pointer;
}
.ocr-field-item.selected {
	border: 2px solid #2BADE0;
	background-color: rgba(43, 173, 224, 0.05);
}
.ocr-field-item.selected::before {
	content: '';
	position: absolute;
	left: -10px;
	top: 50%;
	transform: translateY(-50%);
	width: 0;
	height: 0;
	border-top: 6px solid transparent;
	border-bottom: 6px solid transparent;
	border-right: 8px solid #2BADE0;
}
.ocr-field-title {
	width: 100%;
	height: 50px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 10px;
	background-color: #FAFAFA;
	border-bottom: 1px solid #ccc;
}
.ocr-field-serial {
	font-size: 13px;
	font-weight: bold;
	color: #999;
}
.orc-field-icon {
	display: flex;
	flex-wrap: nowrap;
	gap: 1rem;
}
.ocr-field-content {
	width: 100%;
	display: grid;
	grid-template-columns: 1fr 3fr;
	gap: 10px;
	padding: 20px 10px;
}
.ocr-field-category {
	width: 100%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
.ocr-field-text {
	font-size: 13px;
	color: #666;
}
.ocr-field-box {
	width: 100%;
}
.pdf-container {
	position: relative;
	width: 100%;
	height: 100%;
	overflow: auto;
	background-color: #f4f4f4;
}
.canvas-container {
	position: absolute;
	top: 0;
	left: 0;
	/* width: 100%; */
	/* height: 100%; */
	z-index: 10;
	pointer-events: none;
}
.canvas-container.canvas-active {
	pointer-events: auto;
}
.drawing-canvas {
	width: 100%;
	height: 100%;
	cursor: crosshair;
}
.canvas-controls {
	position: sticky;
	top: 10px;
	left: 10px;
	float: left;
	z-index: 20;
	background-color: rgba(255, 255, 255, 0.8);
	padding: 5px;
	border-radius: 5px;
	box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}
.canvas-control-btn {
	padding: 5px 10px;
	background-color: #f8f8f8;
	border: 1px solid #ccc;
	border-radius: 3px;
	cursor: pointer;
	font-size: 12px;
}
.canvas-control-btn:hover {
	background-color: #efefef;
}
.drawing-tools {
	position: absolute;
	top: 10px;
	right: 10px;
	background-color: rgba(255, 255, 255, 0.8);
	float: right;
	z-index: 20;
	width: fit-content;
	display: flex;
	padding: 5px;
	border-radius: 5px;
	box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}
.drawing-tool {
	width: 30px;
	height: 30px;
	margin: 0 5px;
	border: 1px solid #ccc;
	background-color: white;
	border-radius: 3px;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
}
.drawing-tool:hover {
	background-color: #f0f0f0;
}
.tool-icon {
	font-size: 18px;
	line-height: 1;
}
.save-icon {
	color: #2cb42c;
}
.cancel-icon {
	color: #ff3b3b;
}
.edit-icon {
	background-image: url("~@/assets/images/project/btn_write_survey.png");
}
.elipsis-input {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.btn-edit, .btn-delete {
    width: 24px;
    height: 24px;
    border: none;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
}

.ocr-result-text {
    background-color: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 4px;
    padding: 8px 12px;
    font-family: 'Pretendard', sans-serif;
    font-size: 14px;
    color: #495057;
    min-height: 20px;
    word-break: break-all;
    white-space: pre-wrap;
}

.ocr-result-text:empty::before {
    content: 'No OCR result yet';
    color: #6c757d;
    font-style: italic;
}
/* .btn-edit, .btn-delete {
	width: 24px;
	height: 24px;
	background-color: transparent;
	border: none;
	cursor: pointer;
	background-repeat: no-repeat;
	background-position: center;
} */
.btn-edit {
	background-image: url("~@/assets/images/project/btn_write_survey.png");
}
.btn-delete {
	background-image: url("~@/assets/images/project/btn_delete.png");
}
</style>